import React from 'react'
import { useViewport } from 'shared/customHooks'
import theme from 'shared/theme'
import styled from 'styled-components'
import LogoTopo1 from '../../../src/assets/images/LogosNovas/portoPlusLogo.png'
import LogoTopoWebp1 from '../../../src/assets/images/LogoPortoNew/logo_porto.png'
import LogoTopo2 from '../../../src/assets/images/LogosNovas/PortoHolding-RGB-H.png'
import LogoTopoWebp2 from '../../../src/assets/images/LogoPortoNew/Grupo 1052x.png'
import { isWebpSupported } from 'react-image-webp/dist/utils'
import MaleIcons from '../../assets/images/ico/male2.png'

export const SearchIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.31499 1.83059C7.75593 -0.610195 11.7287 -0.610195 14.1697 1.83059C16.6101 4.2719 16.6101 8.24392 14.1697 10.6852C11.996 12.8583 8.6105 13.0911 6.17114 11.3942C6.11982 11.6371 6.00235 11.8688 5.81344 12.0577L2.25865 15.6123C1.74062 16.1292 0.903513 16.1292 0.388126 15.6123C-0.129377 15.0948 -0.129377 14.2578 0.388126 13.7419L3.94292 10.1863C4.13076 9.99898 4.36306 9.88098 4.60594 9.82966C2.90791 7.38994 3.14074 4.00523 5.31499 1.83059ZM6.4373 9.56299C8.25968 11.3852 11.2255 11.3852 13.0474 9.56299C14.8687 7.74074 14.8687 4.77561 13.0474 2.95336C11.2255 1.13163 8.25968 1.13163 6.4373 2.95336C4.61493 4.77561 4.61493 7.74074 6.4373 9.56299Z"
      fill="black"
      fillOpacity="0.56"
    />
  </svg>
)

export const LoadIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM12 22.4C6.26667 22.4 1.6 17.7333 1.6 12C1.6 6.26667 6.26667 1.6 12 1.6C17.7333 1.6 22.4 6.26667 22.4 12C22.4 17.7333 17.7333 22.4 12 22.4Z"
      fill={props.color || '#009AF8'}
    />
    <path
      d="M11.7999 5.2002C8.39987 5.2002 5.59987 7.73353 5.1332 11.0002L4.66654 10.6002C4.3332 10.2669 3.86654 10.2669 3.5332 10.6002C3.19987 10.9335 3.19987 11.4002 3.5332 11.7335L5.26654 13.4669C5.39987 13.6002 5.59987 13.6669 5.79987 13.6669C5.99987 13.6669 6.19987 13.6002 6.3332 13.4669L8.06654 11.7335C8.39987 11.4002 8.39987 10.9335 8.06654 10.6002C7.7332 10.2669 7.26654 10.2669 6.9332 10.6002L6.7332 10.8002C7.26654 8.53353 9.3332 6.8002 11.7332 6.8002C14.5999 6.8002 16.9332 9.13353 16.9332 12.0002C16.9332 14.8669 14.5999 17.2002 11.7332 17.2002C11.2665 17.2002 10.9332 17.5335 10.9332 18.0002C10.9332 18.4669 11.2665 18.8002 11.7332 18.8002C15.4665 18.8002 18.5332 15.7335 18.5332 12.0002C18.5332 8.26686 15.5332 5.2002 11.7999 5.2002Z"
      fill={props.color || '#009AF8'}
    />
  </svg>
)

export const ViewMenuIcon = (props) => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.8504 6.185C17.2504 2.231 13.7504 0 10.0004 0C6.2504 0 2.7504 2.231 0.150398 6.185C0.0527152 6.31716 0 6.47716 0 6.6415C0 6.80584 0.0527152 6.96584 0.150398 7.098C2.7504 11.154 6.2504 13.334 10.0004 13.334C13.7504 13.334 17.2504 11.103 19.8504 7.149C19.9481 7.00742 20.0004 6.83949 20.0004 6.6675C20.0004 6.49551 19.9481 6.32758 19.8504 6.186V6.185ZM10.0004 11.66C6.9504 11.66 4.1004 9.886 1.8504 6.692C4.1004 3.447 6.9504 1.673 10.0004 1.673C13.0504 1.673 15.9004 3.447 18.1504 6.641C15.9004 9.886 13.0504 11.66 10.0004 11.66Z"
      fill="#009AF8"
    />
    <path
      d="M10 2.66602C9.20888 2.66602 8.43552 2.90061 7.77772 3.34014C7.11993 3.77966 6.60723 4.40438 6.30448 5.13528C6.00173 5.86619 5.92252 6.67045 6.07686 7.44638C6.2312 8.2223 6.61216 8.93503 7.17157 9.49444C7.73098 10.0539 8.44372 10.4348 9.21964 10.5892C9.99556 10.7435 10.7998 10.6643 11.5307 10.3615C12.2616 10.0588 12.8864 9.54609 13.3259 8.8883C13.7654 8.2305 14 7.45714 14 6.66602C13.9968 5.60612 13.5744 4.59055 12.8249 3.84109C12.0755 3.09163 11.0599 2.66918 10 2.66602ZM10 9.16602C9.33249 9.15267 8.6968 8.87816 8.2294 8.40141C7.762 7.92466 7.50013 7.28367 7.5 6.61602C7.49578 6.28417 7.55719 5.95477 7.68071 5.64674C7.80424 5.33872 7.98743 5.05815 8.21976 4.82117C8.4521 4.58419 8.72898 4.39548 9.0345 4.26588C9.34002 4.13629 9.66814 4.06836 10 4.06602C10.6639 4.08461 11.2944 4.36143 11.7575 4.83762C12.2205 5.31381 12.4796 5.95182 12.4796 6.61602C12.4796 7.28022 12.2205 7.91823 11.7575 8.39441C11.2944 8.8706 10.6639 9.14742 10 9.16602Z"
      fill="#009AF8"
    />
  </svg>
)

export const TicketIcon = (props) => (
  <svg
    width={props.width || '48'}
    height={props.height || '48'}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.577 22.701C28.0117 21.729 27.272 20.8696 26.395 20.166C27.3311 18.9363 27.8361 17.4325 27.832 15.887C27.7621 13.999 26.9629 12.2116 25.6024 10.9007C24.242 9.58967 22.4263 8.85718 20.537 8.85718C18.6477 8.85718 16.8319 9.58967 15.4715 10.9007C14.1111 12.2116 13.3119 13.999 13.242 15.887C13.237 17.4326 13.7413 18.9368 14.677 20.167C13.8007 20.8705 13.0617 21.7295 12.497 22.701C11.6977 24.0769 11.2768 25.6398 11.277 27.231L11.277 29.525C11.2823 30.1469 11.534 30.7413 11.977 31.1777C12.42 31.6142 13.0181 31.857 13.64 31.853H27.44C28.0618 31.857 28.6599 31.6142 29.1029 31.1777C29.5459 30.7413 29.7977 30.1469 29.803 29.525V27.231C29.8013 25.6393 29.3783 24.0764 28.577 22.701ZM20.538 10.817C21.8925 10.8085 23.1951 11.3376 24.16 12.2883C25.1249 13.2389 25.6734 14.5335 25.685 15.888C25.6584 17.2355 25.1045 18.5189 24.1421 19.4625C23.1798 20.406 21.8857 20.9346 20.538 20.9346C19.1902 20.9346 17.8962 20.406 16.9338 19.4625C15.9715 18.5189 15.4175 17.2355 15.391 15.888C15.4026 14.5335 15.951 13.2389 16.9159 12.2883C17.8809 11.3376 19.1835 10.8085 20.538 10.817ZM16.211 21.67C17.4691 22.5827 18.9837 23.0742 20.538 23.0742C22.0923 23.0742 23.6068 22.5827 24.865 21.67C25.6125 22.2361 26.2411 22.944 26.715 23.753C27.3282 24.8092 27.6511 26.0088 27.651 27.23V29.524C27.6508 29.5521 27.6452 29.5798 27.6343 29.6057C27.6234 29.6316 27.6075 29.655 27.5875 29.6747C27.5676 29.6944 27.5439 29.71 27.5179 29.7205C27.4919 29.731 27.464 29.7363 27.436 29.736H13.64C13.6119 29.7363 13.5841 29.731 13.5581 29.7205C13.5321 29.71 13.5084 29.6944 13.4884 29.6747C13.4684 29.655 13.4526 29.6316 13.4417 29.6057C13.4308 29.5798 13.4251 29.5521 13.425 29.524V27.231C13.4248 26.0098 13.7478 24.8102 14.361 23.754C14.8348 22.9446 15.4634 22.2364 16.211 21.67Z"
      fill="#009AF8"
    />
    <path
      d="M21 2C15.9249 2 11.1536 3.97634 7.56497 7.56497C3.97634 11.1536 2 15.9249 2 21C2 26.0751 3.97634 30.8464 7.56497 34.435C11.1536 38.0237 15.9249 40 21 40C26.0751 40 30.8464 38.0237 34.435 34.435C38.0237 30.8464 40 26.0751 40 21C40 15.9249 38.0237 11.1536 34.435 7.56497C30.8464 3.97634 26.0751 2 21 2ZM21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0Z"
      fill="#009AF8"
    />
  </svg>
)

export const ProfileIcon = (props) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.577 22.701C28.0117 21.729 27.272 20.8696 26.395 20.166C27.3311 18.9363 27.8361 17.4325 27.832 15.887C27.7621 13.999 26.9629 12.2116 25.6024 10.9007C24.242 9.58967 22.4263 8.85718 20.537 8.85718C18.6477 8.85718 16.8319 9.58967 15.4715 10.9007C14.1111 12.2116 13.3119 13.999 13.242 15.887C13.237 17.4326 13.7413 18.9368 14.677 20.167C13.8007 20.8705 13.0617 21.7295 12.497 22.701C11.6977 24.0769 11.2768 25.6398 11.277 27.231L11.277 29.525C11.2823 30.1469 11.534 30.7413 11.977 31.1777C12.42 31.6142 13.0181 31.857 13.64 31.853H27.44C28.0618 31.857 28.6599 31.6142 29.1029 31.1777C29.5459 30.7413 29.7977 30.1469 29.803 29.525V27.231C29.8013 25.6393 29.3783 24.0764 28.577 22.701ZM20.538 10.817C21.8925 10.8085 23.1951 11.3376 24.16 12.2883C25.1249 13.2389 25.6734 14.5335 25.685 15.888C25.6584 17.2355 25.1045 18.5189 24.1421 19.4625C23.1798 20.406 21.8857 20.9346 20.538 20.9346C19.1902 20.9346 17.8962 20.406 16.9338 19.4625C15.9715 18.5189 15.4175 17.2355 15.391 15.888C15.4026 14.5335 15.951 13.2389 16.9159 12.2883C17.8809 11.3376 19.1835 10.8085 20.538 10.817ZM16.211 21.67C17.4691 22.5827 18.9837 23.0742 20.538 23.0742C22.0923 23.0742 23.6068 22.5827 24.865 21.67C25.6125 22.2361 26.2411 22.944 26.715 23.753C27.3282 24.8092 27.6511 26.0088 27.651 27.23V29.524C27.6508 29.5521 27.6452 29.5798 27.6343 29.6057C27.6234 29.6316 27.6075 29.655 27.5875 29.6747C27.5676 29.6944 27.5439 29.71 27.5179 29.7205C27.4919 29.731 27.464 29.7363 27.436 29.736H13.64C13.6119 29.7363 13.5841 29.731 13.5581 29.7205C13.5321 29.71 13.5084 29.6944 13.4884 29.6747C13.4684 29.655 13.4526 29.6316 13.4417 29.6057C13.4308 29.5798 13.4251 29.5521 13.425 29.524V27.231C13.4248 26.0098 13.7478 24.8102 14.361 23.754C14.8348 22.9446 15.4634 22.2364 16.211 21.67Z"
      fill={props.color || '#009AF8'}
    />
    <path
      d="M21 2C15.9249 2 11.1536 3.97634 7.56497 7.56497C3.97634 11.1536 2 15.9249 2 21C2 26.0751 3.97634 30.8464 7.56497 34.435C11.1536 38.0237 15.9249 40 21 40C26.0751 40 30.8464 38.0237 34.435 34.435C38.0237 30.8464 40 26.0751 40 21C40 15.9249 38.0237 11.1536 34.435 7.56497C30.8464 3.97634 26.0751 2 21 2ZM21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0Z"
      fill={props.color || '#009AF8'}
    />
  </svg>
)

export const MenuIcon = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.7 8.4H1.29998C0.599976 8.4 0.0999756 7.9 0.0999756 7.2C0.0999756 6.5 0.599976 6 1.29998 6H34.8C35.5 6 36 6.5 36 7.2C36 7.9 35.4 8.4 34.7 8.4Z"
      fill="#009AF8"
    />
    <path
      d="M34.7 18.7999H1.29998C0.599976 18.7999 0.0999756 18.2999 0.0999756 17.5999C0.0999756 16.8999 0.599976 16.3999 1.29998 16.3999H34.8C35.5 16.3999 36 16.8999 36 17.5999C35.9 18.2999 35.4 18.7999 34.7 18.7999Z"
      fill="#009AF8"
    />
    <path
      d="M34.8 29.1998H1.2C0.5 29.1998 0 28.6998 0 27.9998C0 27.2998 0.5 26.7998 1.2 26.7998H34.8C35.5 26.7998 36 27.2998 36 27.9998C36 28.6998 35.5 29.1998 34.8 29.1998Z"
      fill="#009AF8"
    />
  </svg>
)

export const CircleDolarIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8444 10.2666C10.8444 8.75552 9.91105 8.31108 8.62216 7.68886L7.91105 7.3333C6.57772 6.66663 6.26661 6.48886 6.26661 5.68886C6.26661 4.66663 7.1555 4.31108 7.99994 4.31108C8.39994 4.31108 9.73327 4.39997 9.73327 5.68886C9.73327 5.99997 9.9555 6.22219 10.2666 6.22219C10.5777 6.22219 10.7999 5.99997 10.7999 5.68886C10.7999 4.39997 9.91105 3.46663 8.53327 3.28886V2.66663C8.53327 2.35552 8.31105 2.1333 7.99994 2.1333C7.68883 2.1333 7.51105 2.35552 7.51105 2.66663V3.28886C6.13327 3.46663 5.24438 4.39997 5.24438 5.68886C5.24438 7.19997 6.17772 7.64441 7.46661 8.26663L8.17772 8.62219C9.51105 9.28886 9.82216 9.46663 9.82216 10.2666C9.82216 11.5555 8.48883 11.6444 8.08883 11.6444C7.68883 11.6444 6.3555 11.5555 6.3555 10.2666C6.3555 9.95552 6.13327 9.7333 5.82216 9.7333C5.51105 9.7333 5.28883 9.95552 5.28883 10.2666C5.28883 11.5555 6.17772 12.4889 7.5555 12.6666V13.3333C7.5555 13.6444 7.77772 13.8666 8.08883 13.8666C8.39994 13.8666 8.62216 13.6444 8.62216 13.3333V12.6666C9.9555 12.4889 10.8444 11.6 10.8444 10.2666Z"
      fill="#074692"
    />
    <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.9333C4.17778 14.9333 1.06667 11.8222 1.06667 8C1.06667 4.17778 4.17778 1.06667 8 1.06667C11.8222 1.06667 14.9333 4.17778 14.9333 8C14.9333 11.8222 11.8222 14.9333 8 14.9333Z"
      fill="#074692"
    />
  </svg>
)

export const MaleFemale = () => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip2)">
      <path
        d="M34.7515 32.8L33.6849 29.7333C40.6182 28.1333 43.4182 23.6 44.2182 22.1333C44.4849 21.6 44.4849 21.0666 44.2182 20.5333C43.0182 18.5333 41.0182 14.9333 40.7515 13.6C38.8849 5.86662 34.2182 1.19995 28.0849 1.19995C27.1515 1.19995 26.4849 1.86662 26.4849 2.79995C26.4849 3.73328 27.1515 4.39995 28.0849 4.39995C34.6182 4.39995 36.8849 11.3333 37.6849 14.2666C38.0849 16 40.0849 19.6 41.1515 21.3333C39.9515 23.3333 36.3515 27.0666 28.2182 27.0666C27.2849 27.0666 26.6182 27.7333 26.6182 28.6666C26.6182 29.6 27.2849 30.2666 28.2182 30.2666C29.1515 30.2666 29.9515 30.2666 30.7515 30.1333L32.2182 34.6666C32.4849 35.3333 33.0182 35.7333 33.6849 35.7333C38.4849 35.7333 45.0182 39.6 45.0182 43.3333C45.0182 44.2666 45.6849 44.9333 46.6182 44.9333C47.5515 44.9333 48.2182 44.2666 48.2182 43.3333C48.0849 37.7333 40.4849 33.3333 34.7515 32.8Z"
        fill="white"
      />
      <path
        d="M23.5513 34.4H21.6847L19.9513 31.6C22.8847 29.3333 25.1514 26 25.6847 22.6666C26.618 22.1333 27.1513 21.0666 27.1513 19.6V15.8666C27.1513 14.6666 26.3514 13.7333 25.6847 13.2V10.8C27.418 8.26663 27.2847 5.46663 25.1513 3.3333C22.3513 0.399963 16.4847 -0.400037 11.2847 3.06663C4.61802 3.19996 1.68468 5.3333 1.68468 10.2666V13.2C1.01802 13.7333 0.218018 14.6666 0.218018 15.8666V19.7333C0.218018 20.5333 0.218017 21.7333 1.28468 22.5333C1.68468 26 3.95135 29.6 6.88468 31.7333L5.01802 34.4H3.01802C2.08468 34.4 1.41802 35.0666 1.41802 36C1.41802 36.9333 2.08468 37.6 3.01802 37.6H5.81802C6.35135 37.6 6.88468 37.3333 7.15135 36.9333L9.55135 33.3333C10.7514 33.8666 11.9514 34.1333 13.1514 34.1333C14.4847 34.1333 15.818 33.8666 17.018 33.2L19.2847 36.8C19.5513 37.3333 20.0847 37.6 20.618 37.6H23.418C25.2847 37.6 31.1513 38 31.1513 43.6V45.6C31.1513 46.5333 31.818 47.2 32.7513 47.2C33.6847 47.2 34.3513 46.5333 34.3513 45.6V43.6C34.3513 38 30.0847 34.4 23.5513 34.4ZM4.35135 21.3333C4.35135 20.6666 3.95135 20.1333 3.28468 19.8666C3.28468 19.8666 3.28468 19.7333 3.28468 19.6V15.8666C3.41802 15.7333 3.68468 15.4666 3.95135 15.3333C4.48468 15.0666 4.75135 14.5333 4.75135 14V10.2666C4.75135 8.39996 4.75135 6.26663 11.6847 6.26663C12.0847 6.26663 12.3513 6.1333 12.618 5.99996C16.7513 2.9333 21.018 3.99996 22.618 5.59996C23.6847 6.66663 23.6847 7.99996 22.618 9.19996C22.3513 9.46663 22.218 9.86663 22.218 10.1333V13.8666C22.218 14.4 22.4847 14.9333 23.018 15.2C23.2847 15.3333 23.5513 15.6 23.6847 15.7333V19.3333C23.6847 19.4666 23.6847 19.4666 23.6847 19.6C22.8847 19.7333 22.3514 20.4 22.3514 21.2C22.3514 25.4666 17.2847 30.6666 13.1514 30.6666C9.15135 30.8 4.35135 25.7333 4.35135 21.3333Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip2">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0.0847168)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const HouseWindow = (props) => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip1)">
      <path
        d="M29.9515 7.06677L15.2848 17.3334V25.8668C15.2848 26.2668 14.7515 26.5334 14.4848 26.2668L9.6848 23.0668H9.55147L0.751465 28.9334V46.1334C0.751465 46.4001 1.01813 46.6668 1.2848 46.6668H44.0848C44.3515 46.6668 44.6181 46.4001 44.6181 46.1334V17.6001C44.6181 17.4668 44.4848 17.2001 44.3515 17.2001L29.9515 7.06677ZM3.81813 43.6001V30.4001L9.55147 26.5334L15.2848 30.4001V43.6001H3.81813ZM32.7515 35.0668V43.4668H27.1515V35.0668H32.7515ZM23.9515 31.6001V43.4668H18.3515V18.5334L29.8181 10.2668L41.2848 18.5334V43.4668H35.6848V31.6001H23.9515Z"
        fill={props.color || '#FFFFFF'}
      />
      <path
        d="M31.5514 17.4667C27.0181 16.2667 22.8848 20.2667 24.2181 24.8C24.7514 26.8 26.3514 28.4 28.3514 28.9334C32.8848 30.1334 36.8848 26.1334 35.6848 21.6C35.1514 19.6 33.5514 18 31.5514 17.4667ZM32.6181 22.5334C33.1514 24.5334 31.2847 26.4 29.2847 25.8667C28.3514 25.6 27.5514 24.8 27.2847 23.8667C26.7514 21.8667 28.6181 20 30.6181 20.5334C31.5514 20.8 32.3514 21.6 32.6181 22.5334Z"
        fill={props.color || '#FFFFFF'}
      />
      <path
        d="M30.8847 1.60005C30.3514 1.20005 29.5514 1.20005 29.018 1.60005L12.3514 13.4667L12.218 13.6L13.6847 15.7334C13.818 16.0001 14.218 16 14.4847 15.8667L29.6847 5.06672C29.818 4.93338 30.0847 4.93338 30.3514 5.06672L45.818 16.1334L45.9514 16.2667L47.418 14C47.5513 13.7334 47.5514 13.4667 47.2847 13.3334L30.8847 1.60005Z"
        fill={props.color || '#FFFFFF'}
      />
    </g>
    <defs>
      <clipPath id="clip1">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0.0847168)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const Car = (props) => (
  <svg
    width={props.width || '48'}
    height={props.height || '34'}
    viewBox="0 0 48 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44.8849 22.6C44.8849 23.4 44.2182 24.2 43.4182 24.2C42.6182 20.8666 39.6849 18.4666 36.0849 18.4666C32.4849 18.4666 29.5515 21 28.7515 24.3333H19.2849C18.4849 21 15.5515 18.4666 11.9515 18.4666C8.75154 18.4666 6.08487 20.4666 5.0182 23.2666C3.95154 22.3333 3.15154 21 3.15154 19.5333V14.3333C3.15154 13.4 3.8182 12.7333 4.75154 12.7333H36.7515C41.1515 12.7333 44.7515 16.3333 44.7515 20.7333L44.8849 22.6ZM36.0849 30.2C34.2182 30.2 32.6182 29 32.0849 27.4C31.9515 26.8666 31.8182 26.4666 31.8182 25.9333C31.8182 25.2666 31.9515 24.7333 32.2182 24.2C32.8849 22.7333 34.3515 21.6666 36.2182 21.6666C38.0849 21.6666 39.5515 22.7333 40.2182 24.2C40.4849 24.7333 40.6182 25.2666 40.6182 25.9333C40.6182 26.4666 40.4849 27 40.3515 27.4C39.5515 29 37.9515 30.2 36.0849 30.2ZM12.0849 30.2C10.2182 30.2 8.6182 29 8.08487 27.4C7.95154 26.8666 7.8182 26.4666 7.8182 25.9333C7.8182 25.2666 7.95154 24.7333 8.2182 24.2C8.88487 22.7333 10.3515 21.6666 12.2182 21.6666C14.0849 21.6666 15.5515 22.7333 16.2182 24.2C16.4849 24.7333 16.6182 25.2666 16.6182 25.9333C16.6182 26.4666 16.4849 27 16.3515 27.4C15.5515 29 13.9515 30.2 12.0849 30.2ZM16.2182 3.79998H18.7515V9.39998H9.4182C9.95154 6.19998 12.7515 3.79998 16.2182 3.79998ZM24.3515 3.79998C27.6849 3.79998 30.4849 6.19998 31.1515 9.39998H21.8182V3.79998H24.3515ZM36.8849 9.39998H34.3515C33.6849 4.46664 29.4182 0.599976 24.3515 0.599976H16.0849C10.8849 0.599976 6.75154 4.46664 6.08487 9.39998H4.75154C2.08487 9.39998 -0.0484619 11.5333 -0.0484619 14.2V19.4C-0.0484619 22.6 1.8182 25.2666 4.48487 26.6C4.88487 30.4666 7.95154 33.4 11.9515 33.4C15.5515 33.4 18.6182 30.8666 19.2849 27.4H28.6182C29.2849 30.8666 32.3515 33.4 35.9515 33.4C39.5515 33.4 42.6182 30.8666 43.2849 27.4C45.8182 27.2666 47.9515 25.2666 47.9515 22.6V20.6C48.0849 14.4666 43.0182 9.39998 36.8849 9.39998Z"
      fill={props.color || '#FFFFFF'}
    />
  </svg>
)

export const Building = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.9534 23.3333V9.19996C35.9534 8.66663 35.6867 8.26663 35.2867 7.99996L26.0867 1.19996C25.5534 0.799961 24.8867 0.533295 24.2201 0.533295C23.9534 0.533295 23.8201 0.533295 23.5534 0.533295H2.48672C1.55339 0.666628 0.886719 1.33329 0.886719 2.26663V45.8666C0.886719 46.6666 1.55339 47.4666 2.48672 47.4666H46.0867C46.8867 47.4666 47.6867 46.8 47.6867 45.8666V32.6666C47.6867 32.1333 47.4201 31.7333 47.0201 31.3333L36.7534 24.5333C36.2201 24.2666 35.9534 23.7333 35.9534 23.3333ZM24.3534 22.5333V6.93329C24.3534 5.73329 25.8201 4.93329 26.7534 5.73329L32.0867 9.7333C32.4867 9.99996 32.7534 10.5333 32.7534 10.9333V22.6666C32.7534 23.4666 32.0867 24.2666 31.1534 24.2666H25.8201C25.0201 24.1333 24.3534 23.3333 24.3534 22.5333ZM26.4867 40.2666V42.6666C26.4867 43.4666 25.8201 44.2666 24.8867 44.2666H22.7534C21.9534 44.2666 21.1534 43.6 21.1534 42.6666V40.4C21.1534 39.6 21.8201 38.8 22.7534 38.8H24.8867C25.8201 38.8 26.4867 39.4666 26.4867 40.2666ZM32.7534 28.8V42.6666C32.7534 43.4666 32.0867 44.2666 31.1534 44.2666C30.3534 44.2666 29.5534 43.6 29.5534 42.6666V37.2C29.5534 36.4 28.8867 35.6 27.9534 35.6H19.4201C18.6201 35.6 17.8201 36.2666 17.8201 37.2V42.6666C17.8201 43.4666 17.1534 44.2666 16.2201 44.2666H5.68672C4.75339 44.1333 4.08672 43.4666 4.08672 42.6666V5.46663C4.08672 4.66663 4.75339 3.86663 5.68672 3.86663H19.5534C20.3534 3.86663 21.1534 4.53329 21.1534 5.46663V25.7333C21.1534 26.5333 21.8201 27.3333 22.7534 27.3333H31.2867C32.0867 27.3333 32.7534 28 32.7534 28.8ZM35.9534 42.6666V30.8C35.9534 29.6 37.2867 28.8 38.3534 29.4666L43.6867 33.0666C44.0867 33.3333 44.3534 33.8666 44.3534 34.4V42.6666C44.3534 43.4666 43.6867 44.2666 42.7534 44.2666H37.4201C36.6201 44.1333 35.9534 43.4666 35.9534 42.6666Z"
      fill="white"
    />
    <path
      d="M11.1531 32.4C12.8865 32.4 14.3531 30.9333 14.3531 29.2C14.3531 27.4667 12.8865 26 11.1531 26C9.41979 26 7.95312 27.4667 7.95312 29.2C7.95312 30.9333 9.41979 32.4 11.1531 32.4Z"
      fill="white"
    />
    <path
      d="M11.1531 41.8666C12.8865 41.8666 14.3531 40.3999 14.3531 38.6666C14.3531 36.9333 12.8865 35.4666 11.1531 35.4666C9.41979 35.4666 7.95312 36.9333 7.95312 38.6666C7.95312 40.3999 9.41979 41.8666 11.1531 41.8666Z"
      fill="white"
    />
    <path
      d="M11.1531 22.7999C12.8865 22.7999 14.3531 21.3333 14.3531 19.5999C14.3531 17.8666 12.8865 16.3999 11.1531 16.3999C9.41979 16.3999 7.95312 17.8666 7.95312 19.5999C7.95312 21.3333 9.41979 22.7999 11.1531 22.7999Z"
      fill="white"
    />
    <path
      d="M11.1531 13.3333C12.8865 13.3333 14.3531 11.8667 14.3531 10.1333C14.3531 8.39999 12.8865 6.93332 11.1531 6.93332C9.41979 6.93332 7.95312 8.39999 7.95312 10.1333C7.95312 11.8667 9.41979 13.3333 11.1531 13.3333Z"
      fill="white"
    />
  </svg>
)

export const ArrowIcon = (props) => (
  <ArrowDirection direction={props.direction}>
    <svg
      width={props.width || '22'}
      height={props.height || '32'}
      viewBox="0 0 22 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6 14.9334L3.08889 0.266746C2.55556 -0.177699 1.66667 -0.0888098 1.22223 0.444524C0.777783 1.06675 0.777783 1.86675 1.4 2.40008L17.6667 16.0001L1.4 29.6001C0.866671 30.0445 0.777783 30.9334 1.22223 31.4667C1.48889 31.8223 1.84445 32.0001 2.20001 32.0001C2.46667 32.0001 2.82223 31.9112 3.08889 31.7334L20.6 17.0667C20.8667 16.8001 21.0444 16.4445 21.0444 16.0001C21.1333 15.6445 20.9556 15.2001 20.6 14.9334Z"
        fill={props.color || '#009AF8'}
      />
    </svg>
  </ArrowDirection>
)

const ArrowDirection = styled.span`
  svg {
    transform: ${(props) => {
      if (props.direction === 'right') return 'rotate(0deg);'
      if (props.direction === 'left') return 'rotate(180deg);'
      if (props.direction === 'down') return 'rotate(90deg);'
      if (props.direction === 'up') return 'rotate(-90deg);'
    }};
  }
`

export const LogoIcon = (props) => {
  const { width } = useViewport()
  const bp = theme.breakpoints.desktopSmall
  return (
    <>
      {isWebpSupported() ? (
        <>
          <div className="logoHeader" >
            <img
              width={width < bp ? 100 : '60%'}
              height={width < bp ? 30 : 26}
              src={LogoTopo1}
              alt="Porto"
            />
            <span className="bordaLogo"></span>
            <img
              width={width < bp ? 120 : '45%'}
              height={width < bp ? 60 : 60}
              src={LogoTopo2}
              alt="Porto"
            />
          </div>
        </>
      ) : (
        <>
          <div className='logoHeader'>
            <img
              width={width < bp ? 100 : '45%'}
              height={width < bp ? 30 : 30}
              src={LogoTopo1}
              alt="Porto"
            />
            <img
              width={width < bp ? 120 : '45%'}
              height={width < bp ? 60 : 65}
              src={LogoTopo2}
              alt="Porto"
            />
          </div>
        </>
      )}
    </>
  )
}

export const Male = () => {
  return <img width="24" height="24" src={MaleIcons} />
}

export const PersonIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 2C10 3.06667 9.15556 3.95556 8.08889 4C10.2667 4.04444 12 5.82222 12 8V10H10.9333V8C10.9333 6.4 9.6 5.06667 8 5.06667C6.4 5.06667 5.06667 6.4 5.06667 8V10H4V8C4 5.82222 5.73333 4.04444 7.91111 4C6.84444 3.95556 6 3.06667 6 2C6 0.888889 6.88889 0 8 0C9.11111 0 10 0.888889 10 2ZM8.00001 1.06665C7.46667 1.06665 7.06667 1.46665 7.06667 1.99998C7.06667 2.53331 7.46667 2.93331 8.00001 2.93331C8.53334 2.93331 8.93334 2.53331 8.93334 1.99998C8.93334 1.46665 8.53334 1.06665 8.00001 1.06665ZM6.66666 16C6.97778 16 7.2 15.7778 7.2 15.4667V8.53333C7.2 8.22222 6.97778 8 6.66666 8C6.35555 8 6.13333 8.22222 6.13333 8.53333V15.4667C6.13333 15.7778 6.35555 16 6.66666 16ZM9.86666 15.4667C9.86666 15.7778 9.64444 16 9.33333 16C9.02222 16 8.8 15.7778 8.8 15.4667V8.53333C8.8 8.22222 9.02222 8 9.33333 8C9.64444 8 9.86666 8.22222 9.86666 8.53333V15.4667Z"
      fill="#009AF8"
    />
    <mask
      id="mask2"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="4"
      y="0"
      width="8"
      height="16"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 2C10 3.06667 9.15556 3.95556 8.08889 4C10.2667 4.04444 12 5.82222 12 8V10H10.9333V8C10.9333 6.4 9.6 5.06667 8 5.06667C6.4 5.06667 5.06667 6.4 5.06667 8V10H4V8C4 5.82222 5.73333 4.04444 7.91111 4C6.84444 3.95556 6 3.06667 6 2C6 0.888889 6.88889 0 8 0C9.11111 0 10 0.888889 10 2ZM8.00001 1.06665C7.46667 1.06665 7.06667 1.46665 7.06667 1.99998C7.06667 2.53331 7.46667 2.93331 8.00001 2.93331C8.53334 2.93331 8.93334 2.53331 8.93334 1.99998C8.93334 1.46665 8.53334 1.06665 8.00001 1.06665ZM6.66666 16C6.97778 16 7.2 15.7778 7.2 15.4667V8.53333C7.2 8.22222 6.97778 8 6.66666 8C6.35555 8 6.13333 8.22222 6.13333 8.53333V15.4667C6.13333 15.7778 6.35555 16 6.66666 16ZM9.86666 15.4667C9.86666 15.7778 9.64444 16 9.33333 16C9.02222 16 8.8 15.7778 8.8 15.4667V8.53333C8.8 8.22222 9.02222 8 9.33333 8C9.64444 8 9.86666 8.22222 9.86666 8.53333V15.4667Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2)">
      <rect width="16" height="16" fill="white" />
    </g>
  </svg>
)

export const BuildingIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="#FFF"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9555 7.77773V3.06662C11.9555 2.88885 11.8666 2.75551 11.7333 2.66662L8.6666 0.399957C8.48882 0.266623 8.2666 0.177734 8.04438 0.177734C7.95549 0.177734 7.91105 0.177734 7.82216 0.177734H0.799935C0.488824 0.222179 0.266602 0.444401 0.266602 0.755512V15.2888C0.266602 15.5555 0.488824 15.8222 0.799935 15.8222H15.3333C15.5999 15.8222 15.8666 15.6 15.8666 15.2888V10.8888C15.8666 10.7111 15.7777 10.5777 15.6444 10.4444L12.2222 8.17773C12.0444 8.08884 11.9555 7.91107 11.9555 7.77773ZM8.08882 7.51107V2.31107C8.08882 1.91107 8.57771 1.6444 8.88882 1.91107L10.6666 3.2444C10.7999 3.33329 10.8888 3.51107 10.8888 3.6444V7.55551C10.8888 7.82218 10.6666 8.08885 10.3555 8.08885H8.57771C8.31105 8.0444 8.08882 7.77773 8.08882 7.51107ZM8.79993 13.4222V14.2222C8.79993 14.4888 8.57771 14.7555 8.2666 14.7555H7.55549C7.28882 14.7555 7.02216 14.5333 7.02216 14.2222V13.4666C7.02216 13.2 7.24438 12.9333 7.55549 12.9333H8.2666C8.57771 12.9333 8.79993 13.1555 8.79993 13.4222ZM10.8888 9.59996V14.2222C10.8888 14.4888 10.6666 14.7555 10.3555 14.7555C10.0888 14.7555 9.82216 14.5333 9.82216 14.2222V12.4C9.82216 12.1333 9.59993 11.8666 9.28882 11.8666H6.44438C6.17771 11.8666 5.91105 12.0888 5.91105 12.4V14.2222C5.91105 14.4888 5.68882 14.7555 5.37771 14.7555H1.8666C1.55549 14.7111 1.33327 14.4888 1.33327 14.2222V1.82218C1.33327 1.55551 1.55549 1.28885 1.8666 1.28885H6.48882C6.75549 1.28885 7.02216 1.51107 7.02216 1.82218V8.57773C7.02216 8.8444 7.24438 9.11107 7.55549 9.11107H10.3999C10.6666 9.11107 10.8888 9.33329 10.8888 9.59996ZM11.9555 14.2222V10.2666C11.9555 9.86662 12.3999 9.59996 12.7555 9.82218L14.5333 11.0222C14.6666 11.1111 14.7555 11.2888 14.7555 11.4666V14.2222C14.7555 14.4888 14.5333 14.7555 14.2222 14.7555H12.4444C12.1777 14.7111 11.9555 14.4888 11.9555 14.2222Z"
      fill="#FFF"
    />
    <path
      d="M3.68874 10.8001C4.26651 10.8001 4.7554 10.3112 4.7554 9.73341C4.7554 9.15564 4.26651 8.66675 3.68874 8.66675C3.11096 8.66675 2.62207 9.15564 2.62207 9.73341C2.62207 10.3112 3.11096 10.8001 3.68874 10.8001Z"
      fill="#FFF"
    />
    <path
      d="M3.68874 13.9556C4.26651 13.9556 4.7554 13.4667 4.7554 12.8889C4.7554 12.3112 4.26651 11.8223 3.68874 11.8223C3.11096 11.8223 2.62207 12.3112 2.62207 12.8889C2.62207 13.4667 3.11096 13.9556 3.68874 13.9556Z"
      fill="#FFF"
    />
    <path
      d="M3.68874 7.59989C4.26651 7.59989 4.7554 7.111 4.7554 6.53322C4.7554 5.95544 4.26651 5.46655 3.68874 5.46655C3.11096 5.46655 2.62207 5.95544 2.62207 6.53322C2.62207 7.111 3.11096 7.59989 3.68874 7.59989Z"
      fill="#FFF"
    />
    <path
      d="M3.68874 4.44437C4.26651 4.44437 4.7554 3.95548 4.7554 3.3777C4.7554 2.79992 4.26651 2.31104 3.68874 2.31104C3.11096 2.31104 2.62207 2.79992 2.62207 3.3777C2.62207 3.95548 3.11096 4.44437 3.68874 4.44437Z"
      fill="#FFF"
    />
  </svg>
)

export const ArrowRight = () => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.69497 4.44591L0.774359 0.324592C0.624493 0.199704 0.374716 0.224681 0.249827 0.374548C0.124939 0.549392 0.124939 0.774191 0.299783 0.924057L4.8707 4.74565L0.299783 8.56723C0.149916 8.69212 0.124939 8.9419 0.249827 9.09177C0.32476 9.19168 0.424671 9.24163 0.524582 9.24163C0.599515 9.24163 0.699426 9.21665 0.774359 9.1667L5.69497 5.04538C5.7699 4.97044 5.81985 4.87053 5.81985 4.74565C5.84483 4.64573 5.79488 4.52085 5.69497 4.44591Z"
      fill="#000"
    />
  </svg>
)

export const ArrowLeftMenu = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M6.99989 12L19.1999 1.79998C19.5999 1.46665 19.6666 0.799982 19.3332 0.399982C18.9999 -1.80006e-05 18.3332 -0.0666846 17.9332 0.266649L4.79989 11.2C4.59989 11.4 4.46655 11.6666 4.46655 12C4.46655 12.3333 4.59989 12.6 4.79989 12.8L17.9332 23.8C18.1332 23.9333 18.3332 24 18.5999 24C18.8666 24 19.1999 23.8666 19.3999 23.6666C19.7332 23.2666 19.6666 22.6 19.2666 22.2667L6.99989 12Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const ScrollUpIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="22" cy="22" r="22" fill="#0070D7" />
    <g clipPath="url(#clip3)">
      <path
        d="M31.7777 26.9444L22.6111 15.9999C22.2777 15.611 21.6666 15.611 21.3333 15.9999L12.1666 26.9444C11.8888 27.2777 11.9444 27.8333 12.2777 28.111C12.6111 28.3888 13.1666 28.3333 13.4444 27.9999L22 17.8333L30.5 27.9999C30.6666 28.2221 30.8888 28.2777 31.1666 28.2777C31.3333 28.2777 31.5555 28.2221 31.7222 28.111C32.0555 27.8333 32.1111 27.2777 31.7777 26.9444Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip3">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const ModalCloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1335 12.0001L20.2668 4.86673C20.6001 4.5334 20.6001 4.06673 20.2668 3.7334C19.9335 3.40007 19.4668 3.40007 19.1335 3.7334L12.0001 10.8667L4.86679 3.7334C4.53346 3.40007 4.06679 3.40007 3.73346 3.7334C3.40013 4.06673 3.40013 4.5334 3.73346 4.86673L10.8668 12.0001L3.73346 19.1334C3.40013 19.4667 3.40013 19.9334 3.73346 20.2667C3.86679 20.4001 4.06679 20.5334 4.26679 20.5334C4.46679 20.5334 4.66679 20.4667 4.80013 20.2667L12.0001 13.1334L19.1335 20.2667C19.2668 20.4001 19.4668 20.5334 19.6668 20.5334C19.8668 20.5334 20.0668 20.4667 20.2001 20.2667C20.5335 19.9334 20.5335 19.4667 20.2001 19.1334L13.1335 12.0001Z"
      fill="#B5B5B5"
    />
  </svg>
)

export const EyeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 11.2001C10.8444 11.2001 13.3778 9.11118 14.5333 8.00007C13.3778 6.88895 10.8444 4.80007 8 4.80007C5.15556 4.80007 2.62222 6.88895 1.46667 8.00007C2.62222 9.11118 5.15556 11.2001 8 11.2001ZM8 3.7334C12.4 3.7334 16 8.00007 16 8.00007C16 8.00007 12.4 12.2667 8 12.2667C3.6 12.2667 0 8.00007 0 8.00007C0 8.00007 3.6 3.7334 8 3.7334Z"
      fill="white"
    />
    <path
      d="M7.95545 9.37768C7.15545 9.37768 6.48879 8.71101 6.48879 7.91101C6.48879 7.11101 7.15545 6.44434 7.95545 6.44434C8.75545 6.44434 9.42212 7.11101 9.42212 7.91101C9.42212 8.75545 8.75545 9.37768 7.95545 9.37768ZM5.42212 7.95545C5.42212 9.33323 6.57767 10.4888 7.95545 10.4888C9.33323 10.4888 10.4888 9.33323 10.4888 7.95545C10.4888 6.57767 9.33323 5.42212 7.95545 5.42212C6.57767 5.42212 5.42212 6.53323 5.42212 7.95545Z"
      fill="white"
    />
    <path
      d="M7.91121 2.31111H8.08899C8.35566 2.31111 8.53343 2.13333 8.53343 1.86667V0.444444C8.53343 0.177778 8.35566 0 8.08899 0H7.91121C7.64454 0 7.46677 0.177778 7.46677 0.444444V1.86667C7.46677 2.08889 7.64454 2.31111 7.91121 2.31111Z"
      fill="white"
    />
    <path
      d="M3.55546 2.71122L2.53324 1.689C2.35546 1.51122 2.08879 1.51122 1.91101 1.689L1.77768 1.82233C1.5999 2.00011 1.5999 2.26678 1.77768 2.44455L2.75546 3.42233C2.93324 3.60011 3.1999 3.60011 3.37768 3.42233L3.55546 3.33344C3.73324 3.15566 3.73324 2.889 3.55546 2.71122Z"
      fill="white"
    />
    <path
      d="M14.1777 1.82233L14.0443 1.689C13.8666 1.51122 13.5999 1.51122 13.4221 1.689L12.4443 2.71122C12.2666 2.889 12.2666 3.15566 12.4443 3.33344L12.5777 3.46678C12.7554 3.64455 13.0221 3.64455 13.1999 3.46678L14.1777 2.489C14.3554 2.26678 14.3554 2.00011 14.1777 1.82233Z"
      fill="white"
    />
    <path
      d="M7.91121 16.0001H8.08899C8.35566 16.0001 8.53343 15.8223 8.53343 15.5556V14.1334C8.53343 13.8667 8.35566 13.689 8.08899 13.689H7.91121C7.64454 13.689 7.46677 13.8667 7.46677 14.1334V15.5556C7.46677 15.8223 7.64454 16.0001 7.91121 16.0001Z"
      fill="white"
    />
    <path
      d="M12.4443 13.2888L13.4221 14.2666C13.5999 14.4443 13.8666 14.4443 14.0443 14.2666L14.1777 14.1332C14.3554 13.9555 14.3554 13.6888 14.1777 13.511L13.1999 12.5332C13.0221 12.3555 12.7554 12.3555 12.5777 12.5332L12.4443 12.6666C12.2666 12.8443 12.2666 13.111 12.4443 13.2888Z"
      fill="white"
    />
    <path
      d="M1.77755 14.1777L1.91088 14.311C2.08866 14.4888 2.35533 14.4888 2.53311 14.311L3.55533 13.2888C3.73311 13.111 3.73311 12.8443 3.55533 12.6666L3.422 12.5332C3.24422 12.3555 2.97755 12.3555 2.79977 12.5332L1.77755 13.5555C1.64422 13.7332 1.64422 13.9999 1.77755 14.1777Z"
      fill="white"
    />
  </svg>
)

export const Exit = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <g clip-path="url(#clip1)">
        <path
          d="M4.04422 10.4002C4.13311 10.4891 4.17756 10.6224 4.17756 10.7557C4.17756 10.8891 4.13311 11.0668 3.99978 11.1557C3.77756 11.3335 3.422 11.3335 3.24422 11.1113L0.533114 8.08906C0.355336 7.86684 0.355336 7.60018 0.533114 7.37795L3.24422 4.35573C3.422 4.13351 3.77756 4.13351 3.99978 4.31129C4.222 4.48906 4.222 4.84462 4.04422 5.06684L2.13311 7.20018L11.422 7.20018C11.7331 7.20018 11.9553 7.4224 11.9553 7.73351C11.9553 8.04462 11.7331 8.26684 11.422 8.26684L2.13311 8.26684L4.04422 10.4002Z"
          fill="#009AF8"
        />
        <path
          d="M15.6 15.4667L15.6 0.533333C15.6 0.222222 15.3778 -9.71364e-09 15.0667 -2.33127e-08L5.2889 -4.50713e-07C4.97779 -4.64312e-07 4.75556 0.222222 4.75556 0.533333L4.75556 5.42222C4.75556 5.73333 4.97779 5.95555 5.2889 5.95555C5.60001 5.95556 5.82223 5.73333 5.82223 5.42222L5.82223 1.06667L14.5333 1.06667L14.5333 14.9333L5.82223 14.9333L5.82223 10.0444C5.82223 9.73333 5.60001 9.51111 5.2889 9.51111C4.97779 9.51111 4.75556 9.73333 4.75556 10.0444L4.75556 15.4667C4.75556 15.7778 4.97779 16 5.2889 16L15.0667 16C15.3778 16 15.6 15.7778 15.6 15.4667Z"
          fill="#009AF8"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="red" />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="16"
          height="16"
          fill="red"
          transform="translate(16) rotate(90)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const Receipt = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9333 13.6444C14.9333 14.3556 14.3556 14.9333 13.6444 14.9333H2.35556C1.64444 14.9333 1.06667 14.3556 1.06667 13.6444V5.95556H4.53333C5.33333 5.95556 5.95556 5.33333 5.95556 4.53333V1.06667H13.6444C14.3556 1.06667 14.9333 1.64444 14.9333 2.35556V13.6444ZM4.88889 1.42222V4.53333C4.88889 4.71111 4.71111 4.88889 4.53333 4.88889H1.42222L4.88889 1.42222ZM13.6444 0H4.8L0 4.8V13.6444C0 14.9333 1.06667 16 2.35556 16H13.6444C14.9333 16 16 14.9333 16 13.6444V2.35556C16 1.06667 14.9333 0 13.6444 0Z"
      fill="#009AF8"
    />
    <path
      d="M3.82222 10.8H12.1778C12.4889 10.8 12.7111 10.5778 12.7111 10.2667C12.7111 9.95556 12.4889 9.73334 12.1778 9.73334H3.82222C3.51111 9.73334 3.28889 9.95556 3.28889 10.2667C3.28889 10.5778 3.51111 10.8 3.82222 10.8Z"
      fill="#009AF8"
    />
    <path
      d="M3.82222 8.6667H12.1778C12.4889 8.6667 12.7111 8.44448 12.7111 8.13337C12.7111 7.82226 12.4889 7.60004 12.1778 7.60004H3.82222C3.51111 7.60004 3.28889 7.82226 3.28889 8.13337C3.28889 8.44448 3.51111 8.6667 3.82222 8.6667Z"
      fill="#009AF8"
    />
    <path
      d="M3.82222 12.9334H12.1778C12.4889 12.9334 12.7111 12.7111 12.7111 12.4C12.7111 12.0889 12.4889 11.8667 12.1778 11.8667H3.82222C3.51111 11.8667 3.28889 12.0889 3.28889 12.4C3.28889 12.7111 3.51111 12.9334 3.82222 12.9334Z"
      fill="#009AF8"
    />
  </svg>
)

export const ReceiptActive = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9333 13.6444C14.9333 14.3556 14.3556 14.9333 13.6444 14.9333H2.35556C1.64444 14.9333 1.06667 14.3556 1.06667 13.6444V5.95556H4.53333C5.33333 5.95556 5.95556 5.33333 5.95556 4.53333V1.06667H13.6444C14.3556 1.06667 14.9333 1.64444 14.9333 2.35556V13.6444ZM4.88889 1.42222V4.53333C4.88889 4.71111 4.71111 4.88889 4.53333 4.88889H1.42222L4.88889 1.42222ZM13.6444 0H4.8L0 4.8V13.6444C0 14.9333 1.06667 16 2.35556 16H13.6444C14.9333 16 16 14.9333 16 13.6444V2.35556C16 1.06667 14.9333 0 13.6444 0Z"
      fill="white"
    />
    <path
      d="M3.82215 10.8001H12.1777C12.4888 10.8001 12.711 10.5778 12.711 10.2667C12.711 9.95562 12.4888 9.7334 12.1777 9.7334H3.82215C3.51104 9.7334 3.28882 9.95562 3.28882 10.2667C3.28882 10.5778 3.51104 10.8001 3.82215 10.8001Z"
      fill="white"
    />
    <path
      d="M3.82215 8.66676H12.1777C12.4888 8.66676 12.711 8.44454 12.711 8.13343C12.711 7.82232 12.4888 7.6001 12.1777 7.6001H3.82215C3.51104 7.6001 3.28882 7.82232 3.28882 8.13343C3.28882 8.44454 3.51104 8.66676 3.82215 8.66676Z"
      fill="white"
    />
    <path
      d="M3.82215 12.9334H12.1777C12.4888 12.9334 12.711 12.7111 12.711 12.4C12.711 12.0889 12.4888 11.8667 12.1777 11.8667H3.82215C3.51104 11.8667 3.28882 12.0889 3.28882 12.4C3.28882 12.7111 3.51104 12.9334 3.82215 12.9334Z"
      fill="white"
    />
  </svg>
)

export const Pencil = (props) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 13 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4 6.39819H1.66667C1.66667 6.39819 1.66667 6.39819 1.66667 6.33152C1.66667 3.73152 3.66667 1.59819 6.06667 1.59819C8.4 1.59819 10.4 3.73152 10.4 6.39819ZM7.2 16.7982V7.99819H10.3333V16.7315L7.2 16.7982ZM7.53333 20.5982H4.4L2.4 18.4649V18.3982H9.46667C9.46667 18.3982 9.53333 18.3982 9.46667 18.4649L7.53333 20.5982C7.6 20.5982 7.6 20.5982 7.53333 20.5982ZM1.6 16.7982V7.99819H5.53333V16.7315L1.6 16.7982ZM0 5.99819V17.9982L6 23.9982C6 23.9982 6 23.9982 6.06667 23.9982L12.0667 17.9982V6.26486C12.0667 3.06486 9.66667 0.264857 6.46667 0.064857C2.86667 -0.20181 0 2.53152 0 5.99819Z"
      fill={props.color || '#fff'}
    />
  </svg>
)

export const Calendar = (props) => (
  <svg
    width={props.width || '16'}
    height={props.height || '16'}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9333 12.8C14.9333 13.9556 13.9556 14.9333 12.8 14.9333H3.2C2.04444 14.9333 1.06667 13.9556 1.06667 12.8V6.66667H14.9333V12.8ZM14.9333 5.6H1.06667V4.44444C1.06667 3.28889 2.04444 2.31111 3.2 2.31111H3.46667V3.55556H4.53333V2.31111H7.46667V3.55556H8.53333V2.31111H11.4667V3.55556H12.5333V2.31111H12.8C13.9556 2.31111 14.9333 3.28889 14.9333 4.44444V5.6ZM12.8 1.24444H12.5333V0H11.4667V1.24444H8.53333V0H7.46667V1.24444H4.53333V0H3.46667V1.24444H3.2C1.42222 1.24444 0 2.66667 0 4.44444V5.6V6.66667V12.8C0 14.5778 1.42222 16 3.2 16H12.8C14.5778 16 16 14.5778 16 12.8V6.66667V5.6V4.44444C16 2.66667 14.5778 1.24444 12.8 1.24444Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 9.77774C4.57777 9.77774 5.06666 9.28885 5.06666 8.71108C5.06666 8.1333 4.57777 7.64441 4 7.64441C3.42222 7.64441 2.93333 8.1333 2.93333 8.71108C2.93333 9.3333 3.42222 9.77774 4 9.77774Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.95556 9.77774C8.53333 9.77774 9.02222 9.28885 9.02222 8.71108C9.02222 8.1333 8.53333 7.64441 7.95556 7.64441C7.37778 7.64441 6.88889 8.1333 6.88889 8.71108C6.88889 9.3333 7.37778 9.77774 7.95556 9.77774Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 9.77774C12.5778 9.77774 13.0667 9.28885 13.0667 8.71108C13.0667 8.1333 12.5778 7.64441 12 7.64441C11.4222 7.64441 10.9333 8.1333 10.9333 8.71108C10.9333 9.3333 11.4222 9.77774 12 9.77774Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 13.4666C4.57777 13.4666 5.06666 12.9778 5.06666 12.4C5.06666 11.8222 4.57777 11.3333 4 11.3333C3.42222 11.3333 2.93333 11.8222 2.93333 12.4C2.93333 13.0222 3.42222 13.4666 4 13.4666Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.95556 13.4666C8.53333 13.4666 9.02222 12.9778 9.02222 12.4C9.02222 11.8222 8.53333 11.3333 7.95556 11.3333C7.37778 11.3333 6.88889 11.8222 6.88889 12.4C6.88889 13.0222 7.37778 13.4666 7.95556 13.4666Z"
      fill={props.color || '#009AF8'}
    />
  </svg>
)

export const CalendarActive = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9333 12.8C14.9333 13.9556 13.9556 14.9333 12.8 14.9333H3.2C2.04444 14.9333 1.06667 13.9556 1.06667 12.8V6.66667H14.9333V12.8ZM14.9333 5.6H1.06667V4.44444C1.06667 3.28889 2.04444 2.31111 3.2 2.31111H3.46667V3.55556H4.53333V2.31111H7.46667V3.55556H8.53333V2.31111H11.4667V3.55556H12.5333V2.31111H12.8C13.9556 2.31111 14.9333 3.28889 14.9333 4.44444V5.6ZM12.8 1.24444H12.5333V0H11.4667V1.24444H8.53333V0H7.46667V1.24444H4.53333V0H3.46667V1.24444H3.2C1.42222 1.24444 0 2.66667 0 4.44444V5.6V6.66667V12.8C0 14.5778 1.42222 16 3.2 16H12.8C14.5778 16 16 14.5778 16 12.8V6.66667V5.6V4.44444C16 2.66667 14.5778 1.24444 12.8 1.24444Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.99977 9.77786C4.57755 9.77786 5.06644 9.28898 5.06644 8.7112C5.06644 8.13342 4.57755 7.64453 3.99977 7.64453C3.42199 7.64453 2.93311 8.13342 2.93311 8.7112C2.93311 9.33342 3.42199 9.77786 3.99977 9.77786Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.95534 9.77786C8.53312 9.77786 9.022 9.28898 9.022 8.7112C9.022 8.13342 8.53312 7.64453 7.95534 7.64453C7.37756 7.64453 6.88867 8.13342 6.88867 8.7112C6.88867 9.33342 7.37756 9.77786 7.95534 9.77786Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9998 9.77786C12.5775 9.77786 13.0664 9.28898 13.0664 8.7112C13.0664 8.13342 12.5775 7.64453 11.9998 7.64453C11.422 7.64453 10.9331 8.13342 10.9331 8.7112C10.9331 9.33342 11.422 9.77786 11.9998 9.77786Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.99977 13.4668C4.57755 13.4668 5.06644 12.9779 5.06644 12.4002C5.06644 11.8224 4.57755 11.3335 3.99977 11.3335C3.42199 11.3335 2.93311 11.8224 2.93311 12.4002C2.93311 13.0224 3.42199 13.4668 3.99977 13.4668Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.95534 13.4668C8.53312 13.4668 9.022 12.9779 9.022 12.4002C9.022 11.8224 8.53312 11.3335 7.95534 11.3335C7.37756 11.3335 6.88867 11.8224 6.88867 12.4002C6.88867 13.0224 7.37756 13.4668 7.95534 13.4668Z"
      fill="white"
    />
  </svg>
)

export const Doubt = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.15576 6.04453C5.15576 5.68898 5.28909 5.33342 5.51132 4.93342C5.73354 4.57786 6.08909 4.26675 6.53354 4.00009C6.97798 3.73342 7.51132 3.64453 8.0891 3.64453C8.62243 3.64453 9.11132 3.73342 9.55576 3.95564C10.0002 4.17786 10.3113 4.44453 10.5335 4.80009C10.7558 5.15564 10.8891 5.5112 10.8891 5.95564C10.8891 6.26675 10.8447 6.57786 10.7113 6.80009C10.578 7.02231 10.4447 7.24453 10.2224 7.42231C10.0002 7.60009 9.73354 7.9112 9.24465 8.3112C9.11132 8.44453 9.02243 8.53342 8.93354 8.62231C8.84465 8.7112 8.80021 8.80009 8.75576 8.88898C8.71132 8.97786 8.66687 9.02231 8.66687 9.1112C8.66687 9.20009 8.62243 9.33342 8.57798 9.5112C8.48909 9.9112 8.26687 10.089 7.91132 10.089C7.73354 10.089 7.55576 10.0445 7.42243 9.9112C7.2891 9.77786 7.20021 9.60009 7.20021 9.33342C7.20021 9.02231 7.24465 8.75564 7.33354 8.48898C7.42243 8.26675 7.55576 8.04453 7.73354 7.86675C7.91132 7.68898 8.13354 7.46675 8.40021 7.24453C8.66687 7.02231 8.80021 6.88898 8.93354 6.75564C9.02243 6.66675 9.15576 6.53342 9.20021 6.40009C9.28909 6.26675 9.33354 6.13342 9.33354 5.95564C9.33354 5.64453 9.20021 5.37786 8.97798 5.20009C8.75576 4.97786 8.44465 4.88898 8.0891 4.88898C7.6891 4.88898 7.37798 4.97786 7.15576 5.20009C6.97798 5.42231 6.80021 5.73342 6.66687 6.13342C6.53354 6.57786 6.31132 6.80009 5.91132 6.80009C5.68909 6.80009 5.51132 6.7112 5.37798 6.57786C5.20021 6.40009 5.15576 6.22231 5.15576 6.04453ZM7.91132 12.3556C7.68909 12.3556 7.46687 12.2668 7.28909 12.1334C7.11132 12.0001 7.02243 11.7779 7.02243 11.5112C7.02243 11.289 7.11132 11.0668 7.28909 10.889C7.46687 10.7112 7.64465 10.6223 7.91132 10.6223C8.13354 10.6223 8.35576 10.7112 8.53354 10.889C8.71132 11.0668 8.80021 11.2445 8.80021 11.5112C8.80021 11.7779 8.71132 12.0001 8.53354 12.1334C8.35576 12.2668 8.17798 12.3556 7.91132 12.3556Z"
      fill="#009AF8"
    />
    <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.9333C4.17778 14.9333 1.06667 11.8222 1.06667 8C1.06667 4.17778 4.17778 1.06667 8 1.06667C11.8222 1.06667 14.9333 4.17778 14.9333 8C14.9333 11.8222 11.8222 14.9333 8 14.9333Z"
      fill="#009AF8"
    />
  </svg>
)

export const DoubtActive = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.15576 6.04453C5.15576 5.68898 5.28909 5.33342 5.51132 4.93342C5.73354 4.57786 6.08909 4.26675 6.53354 4.00009C6.97798 3.73342 7.51132 3.64453 8.0891 3.64453C8.62243 3.64453 9.11132 3.73342 9.55576 3.95564C10.0002 4.17786 10.3113 4.44453 10.5335 4.80009C10.7558 5.15564 10.8891 5.5112 10.8891 5.95564C10.8891 6.26675 10.8447 6.57786 10.7113 6.80009C10.578 7.02231 10.4447 7.24453 10.2224 7.42231C10.0002 7.60009 9.73354 7.9112 9.24465 8.3112C9.11132 8.44453 9.02243 8.53342 8.93354 8.62231C8.84465 8.7112 8.80021 8.80009 8.75576 8.88898C8.71132 8.97786 8.66687 9.02231 8.66687 9.1112C8.66687 9.20009 8.62243 9.33342 8.57798 9.5112C8.48909 9.9112 8.26687 10.089 7.91132 10.089C7.73354 10.089 7.55576 10.0445 7.42243 9.9112C7.2891 9.77786 7.20021 9.60009 7.20021 9.33342C7.20021 9.02231 7.24465 8.75564 7.33354 8.48898C7.42243 8.26675 7.55576 8.04453 7.73354 7.86675C7.91132 7.68898 8.13354 7.46675 8.40021 7.24453C8.66687 7.02231 8.80021 6.88898 8.93354 6.75564C9.02243 6.66675 9.15576 6.53342 9.20021 6.40009C9.28909 6.26675 9.33354 6.13342 9.33354 5.95564C9.33354 5.64453 9.20021 5.37786 8.97798 5.20009C8.75576 4.97786 8.44465 4.88898 8.0891 4.88898C7.6891 4.88898 7.37798 4.97786 7.15576 5.20009C6.97798 5.42231 6.80021 5.73342 6.66687 6.13342C6.53354 6.57786 6.31132 6.80009 5.91132 6.80009C5.68909 6.80009 5.51132 6.7112 5.37798 6.57786C5.20021 6.40009 5.15576 6.22231 5.15576 6.04453ZM7.91132 12.3556C7.68909 12.3556 7.46687 12.2668 7.28909 12.1334C7.11132 12.0001 7.02243 11.7779 7.02243 11.5112C7.02243 11.289 7.11132 11.0668 7.28909 10.889C7.46687 10.7112 7.64465 10.6223 7.91132 10.6223C8.13354 10.6223 8.35576 10.7112 8.53354 10.889C8.71132 11.0668 8.80021 11.2445 8.80021 11.5112C8.80021 11.7779 8.71132 12.0001 8.53354 12.1334C8.35576 12.2668 8.17798 12.3556 7.91132 12.3556Z"
      fill="white"
    />
    <path
      d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.9333C4.17778 14.9333 1.06667 11.8222 1.06667 8C1.06667 4.17778 4.17778 1.06667 8 1.06667C11.8222 1.06667 14.9333 4.17778 14.9333 8C14.9333 11.8222 11.8222 14.9333 8 14.9333Z"
      fill="white"
    />
  </svg>
)

export const Check = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 1.06667C11.8222 1.06667 14.9333 4.17778 14.9333 8C14.9333 11.8222 11.8222 14.9333 8 14.9333C4.17778 14.9333 1.06667 11.8222 1.06667 8C1.06667 4.17778 4.17778 1.06667 8 1.06667ZM6.97778 11.0667C7.06667 11.2 7.2 11.2444 7.33333 11.2444H7.37778C7.55556 11.2444 7.68889 11.1556 7.77778 11.0222L11.7778 4.97778C11.9556 4.71111 11.9111 4.4 11.6444 4.22222C11.3778 4.04444 11.0667 4.08889 10.8889 4.35556L7.24444 9.82222L5.02222 7.6C4.8 7.37778 4.48889 7.37778 4.26667 7.6C4.04445 7.82222 4.04445 8.13333 4.26667 8.35556L6.97778 11.0667Z"
        fill="white"
      />
    </mask>

    <g mask="url(#mask0)">
      <rect width="16" height="16" fill="#009AF8" />
    </g>
  </svg>
)

export const CheckActive = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask1"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 1.06667C11.8222 1.06667 14.9333 4.17778 14.9333 8C14.9333 11.8222 11.8222 14.9333 8 14.9333C4.17778 14.9333 1.06667 11.8222 1.06667 8C1.06667 4.17778 4.17778 1.06667 8 1.06667ZM6.97778 11.0667C7.06667 11.2 7.2 11.2444 7.33333 11.2444H7.37778C7.55556 11.2444 7.68889 11.1556 7.77778 11.0222L11.7778 4.97778C11.9556 4.71111 11.9111 4.4 11.6444 4.22222C11.3778 4.04444 11.0667 4.08889 10.8889 4.35556L7.24444 9.82222L5.02222 7.6C4.8 7.37778 4.48889 7.37778 4.26667 7.6C4.04445 7.82222 4.04445 8.13333 4.26667 8.35556L6.97778 11.0667Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1)">
      <rect width="16" height="16" fill="white" />
    </g>
  </svg>
)

export const Phone = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M2.93322 0C2.53322 0 2.13322 0.177778 1.911 0.533333C-0.889004 4.35556 -0.577893 9.73333 2.84433 13.1556C4.75544 15.0667 7.24433 16 9.73322 16C11.7777 16 13.7777 15.3778 15.511 14.0889C16.1332 13.6444 16.2221 12.7556 15.6888 12.2222L12.6666 9.2C12.3554 8.88889 11.911 8.71111 11.511 8.71111C11.0666 8.71111 10.6666 8.88889 10.3554 9.2L8.44433 10.9778C7.64433 10.7556 6.88877 10.3556 6.26655 9.73333C5.64433 9.11111 5.19988 8.35556 5.02211 7.55556L6.84433 5.77778C7.511 5.11111 7.511 4.08889 6.84433 3.42222L3.77766 0.355556C3.55544 0.133333 3.24433 0 2.93322 0ZM2.93322 1.06667C2.97766 1.06667 3.02211 1.11111 3.06655 1.11111L6.08877 4.13333C6.22211 4.26667 6.26655 4.4 6.26655 4.53333C6.26655 4.71111 6.22211 4.84444 6.08877 4.93333L4.26655 6.71111C3.99988 7.06667 3.911 7.46667 3.99988 7.82222C4.26655 8.84444 4.79988 9.73333 5.55544 10.4889C6.311 11.2444 7.19988 11.7778 8.22211 12.0444C8.311 12.0889 8.39989 12.0889 8.48877 12.0889C8.75544 12.0889 9.02211 12 9.24433 11.7778L11.0666 9.95556C11.1999 9.82222 11.3332 9.77778 11.4666 9.77778C11.6443 9.77778 11.7777 9.82222 11.8666 9.95556L14.8888 12.9778C14.8888 12.9778 14.9332 13.0222 14.9332 13.1111C14.9332 13.1556 14.9332 13.2 14.8443 13.2444C13.3332 14.3556 11.5554 14.9333 9.68877 14.9333C7.37766 14.9333 5.19988 14.0444 3.55544 12.4C0.577663 9.37778 0.222107 4.57778 2.75544 1.15556C2.79988 1.06667 2.88877 1.06667 2.93322 1.06667Z"
        fill={props.color || '#8B8B8B'}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const MapMaker = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9999 6.6668C8.88356 6.6668 9.5999 5.95045 9.5999 5.0668C9.5999 4.18314 8.88356 3.4668 7.9999 3.4668C7.11625 3.4668 6.3999 4.18314 6.3999 5.0668C6.3999 5.95045 7.11625 6.6668 7.9999 6.6668Z"
      fill={props.color || '#8B8B8B'}
    />
    <path
      d="M7.99992 16C7.68881 16 7.46659 15.7778 7.46659 15.4667C7.42215 14.9333 5.82215 11.5556 4.39992 10.0889C3.51104 9.15556 2.31104 7.68889 2.31104 5.68889C2.31104 2.53333 4.84437 0 7.99992 0C11.1555 0 13.6888 2.53333 13.6888 5.68889C13.6888 7.42222 12.8444 9.02222 11.2444 10.3556C9.51103 11.8222 8.53326 14.9778 8.53326 15.4667C8.53326 15.7778 8.31104 16 7.99992 16ZM7.99992 1.06667C5.46659 1.06667 3.3777 3.15556 3.3777 5.68889C3.3777 6.93333 3.95548 8.08889 5.19992 9.37778C6.1777 10.4 7.28881 12.3111 7.95548 13.7333C8.44437 12.4 9.33326 10.6222 10.5777 9.55556C11.511 8.75556 12.6666 7.46667 12.6666 5.68889C12.6221 3.15556 10.5333 1.06667 7.99992 1.06667Z"
      fill={props.color || '#8B8B8B'}
    />
  </svg>
)
export const Wifi = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36 36H33.6C33.6 17.5 18.5 2.4 0 2.4V0C19.9 0 36 16.1 36 36Z"
      fill={props.color || '#009AF8'}
    />
    <path
      d="M25.8 35.9992H23.4C23.4 23.0992 12.9 12.5992 0 12.5992V10.1992C14.2 10.1992 25.8 21.7992 25.8 35.9992Z"
      fill={props.color || '#009AF8'}
    />
    <path
      d="M16.5 36H14.1C14.1 28.2 7.8 21.9 0 21.9V19.5C9.1 19.5 16.5 26.9 16.5 36Z"
      fill={props.color || '#009AF8'}
    />
  </svg>
)

export const LongArrow = (props) => (
  <ArrowDirection direction={props.direction}>
    <svg
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8596 7.32789L15.6721 0.140392C15.4849 -0.0467974 15.1817 -0.0467974 14.9946 0.140392C14.8074 0.327582 14.8074 0.630804 14.9946 0.817949L21.3641 7.18751H0.479182C0.214322 7.18751 0 7.40183 0 7.66669C0 7.93155 0.214322 8.14587 0.479182 8.14587H21.3641L14.9946 14.5154C14.8074 14.7026 14.8074 15.0058 14.9946 15.1929C15.0881 15.2865 15.2108 15.3333 15.3334 15.3333C15.456 15.3333 15.5785 15.2865 15.6722 15.1929L22.8597 8.00545C23.0468 7.8183 23.0468 7.51508 22.8596 7.32789Z"
        fill={props.color || '#EC008C'}
      />
    </svg>
  </ArrowDirection>
)

export const DoorHanger = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9 36.1992H12.8C11 36.1992 9.30005 34.4992 9.30005 32.4992V18.6992C9.30005 16.5992 11 15.1992 13.5 15.1992H17.9C18.7 15.1992 19.7 13.9992 19.7 12.9992V8.59922C19.7 7.69922 18.8 7.19922 17.9 7.19922C17.4 7.19922 16.3 7.29922 16.3 8.59922V9.39922C16.3 11.2992 14.6 12.9992 12.8 12.9992C10.9 12.9992 9.30005 11.2992 9.30005 9.39922V8.59922C9.30005 3.99922 13.1 0.199219 17.9 0.199219C22.7 0.199219 26.8 4.09922 26.8 8.59922V32.4992C26.7 34.2992 24.8 36.1992 22.9 36.1992ZM13.5 17.5992C13 17.5992 11.7 17.6992 11.7 18.6992V32.4992C11.7 33.0992 12.3 33.7992 12.8 33.7992H22.9C23.5 33.7992 24.3 32.9992 24.3 32.4992V8.59922C24.3 5.39922 21.3 2.59922 17.8 2.59922C14.5 2.59922 11.6 5.39922 11.6 8.59922V9.39922C11.6 9.89922 12.2 10.5992 12.7 10.5992C13.3 10.5992 13.9 9.89922 13.9 9.39922V8.59922C13.9 6.39922 15.5 4.79922 17.8 4.79922C20.2 4.79922 22.1 6.39922 22.1 8.59922V12.9992C22.1 15.0992 20.3 17.5992 17.9 17.5992H13.5Z"
      fill={props.color || '#009AF8'}
    />
  </svg>
)

export const WheelChair = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5 16.2008C11.0207 16.2008 8.20005 19.0214 8.20005 22.5008C8.20005 25.9802 11.0207 28.8008 14.5 28.8008C17.8378 28.8008 20.5702 26.2044 20.7862 22.922C20.8298 22.2607 21.4011 21.7598 22.0625 21.8034C22.7238 21.8469 23.2246 22.4183 23.1811 23.0796C22.8825 27.6152 19.1105 31.2008 14.5 31.2008C9.69517 31.2008 5.80005 27.3057 5.80005 22.5008C5.80005 17.6959 9.69517 13.8008 14.5 13.8008C15.1628 13.8008 15.7 14.338 15.7 15.0008C15.7 15.6635 15.1628 16.2008 14.5 16.2008Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.2451 7.32647C16.8928 7.18568 17.5319 7.59655 17.6727 8.24416L19.9672 18.7991H25.5001C26.0823 18.7991 26.5806 19.2171 26.6818 19.7905L28.0068 27.2991H29.5001C30.1628 27.2991 30.7001 27.8363 30.7001 28.4991C30.7001 29.1618 30.1628 29.6991 29.5001 29.6991H27.0001C26.4178 29.6991 25.9195 29.2811 25.8183 28.7076L24.4933 21.1991H19.0001C18.4355 21.1991 17.9474 20.8056 17.8274 20.254L15.3274 8.754C15.1867 8.10638 15.5975 7.46725 16.2451 7.32647Z"
      fill={props.color || '#009AF8'}
    />
    <path
      d="M19 7C19 8.65685 17.6569 10 16 10C14.3431 10 13 8.65685 13 7C13 5.34315 14.3431 4 16 4C17.6569 4 19 5.34315 19 7Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17 14.7996C17 14.1369 17.5373 13.5996 18.2 13.5996L24.8 13.5996C25.4627 13.5996 26 14.1369 26 14.7996C26 15.4624 25.4627 15.9996 24.8 15.9996L18.2 15.9996C17.5373 15.9996 17 15.4624 17 14.7996Z"
      fill={props.color || '#009AF8'}
    />
  </svg>
)

export const AirConditioner = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29 4.2H7C6.00589 4.2 5.2 5.00589 5.2 6V11C5.2 11.9941 6.00589 12.8 7 12.8H29C29.9941 12.8 30.8 11.9941 30.8 11V6C30.8 5.00589 29.9941 4.2 29 4.2ZM7 2C4.79086 2 3 3.79086 3 6V11C3 13.2091 4.79086 15 7 15H29C31.2091 15 33 13.2091 33 11V6C33 3.79086 31.2091 2 29 2H7Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0999 3.5V6.5C29.0999 8.21208 27.712 9.6 25.9999 9.6H10.4999C8.78782 9.6 7.3999 8.21208 7.3999 6.5V4H9.5999V6.5C9.5999 6.99706 10.0028 7.4 10.4999 7.4H25.9999C26.497 7.4 26.8999 6.99706 26.8999 6.5V3.5H29.0999Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.9999 16.9004C14.6074 16.9004 15.0999 17.3929 15.0999 18.0004V30.5004C15.0999 32.4886 13.4881 34.1004 11.4999 34.1004C9.51168 34.1004 7.8999 32.4886 7.8999 30.5004V29.1604C7.8999 28.5529 8.39239 28.0604 8.9999 28.0604C9.60742 28.0604 10.0999 28.5529 10.0999 29.1604V30.5004C10.0999 31.2736 10.7267 31.9004 11.4999 31.9004C12.2731 31.9004 12.8999 31.2736 12.8999 30.5004V18.0004C12.8999 17.3929 13.3924 16.9004 13.9999 16.9004Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0001 16.9004C21.3926 16.9004 20.9001 17.3929 20.9001 18.0004V30.5004C20.9001 32.4886 22.5119 34.1004 24.5001 34.1004C26.4883 34.1004 28.1001 32.4886 28.1001 30.5004V29.1604C28.1001 28.5529 27.6076 28.0604 27.0001 28.0604C26.3926 28.0604 25.9001 28.5529 25.9001 29.1604V30.5004C25.9001 31.2736 25.2733 31.9004 24.5001 31.9004C23.7269 31.9004 23.1001 31.2736 23.1001 30.5004V18.0004C23.1001 17.3929 22.6076 16.9004 22.0001 16.9004Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.0001 16.9004C25.3926 16.9004 24.9001 17.3929 24.9001 18.0004V23.0004C24.9001 24.9886 26.5119 26.6004 28.5001 26.6004C30.4883 26.6004 32.1001 24.9886 32.1001 23.0004V21.6604C32.1001 21.0529 31.6076 20.5604 31.0001 20.5604C30.3926 20.5604 29.9001 21.0529 29.9001 21.6604V23.0004C29.9001 23.7736 29.2733 24.4004 28.5001 24.4004C27.7269 24.4004 27.1001 23.7736 27.1001 23.0004V18.0004C27.1001 17.3929 26.6076 16.9004 26.0001 16.9004Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.9999 16.9004C10.6074 16.9004 11.0999 17.3929 11.0999 18.0004V23.0004C11.0999 24.9886 9.48813 26.6004 7.4999 26.6004C5.51168 26.6004 3.8999 24.9886 3.8999 23.0004V21.6604C3.8999 21.0529 4.39239 20.5604 4.9999 20.5604C5.60742 20.5604 6.0999 21.0529 6.0999 21.6604V23.0004C6.0999 23.7736 6.7267 24.4004 7.4999 24.4004C8.2731 24.4004 8.8999 23.7736 8.8999 23.0004V18.0004C8.8999 17.3929 9.39239 16.9004 9.9999 16.9004Z"
      fill={props.color || '#009AF8'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1 17C18.7075 17 19.2 17.4925 19.2 18.1L19.2 26.9C19.2 27.5075 18.7075 28 18.1 28C17.4924 28 17 27.5075 17 26.9L17 18.1C17 17.4925 17.4924 17 18.1 17Z"
      fill={props.color || '#009AF8'}
    />
  </svg>
)
export const Restaurant = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6999 0.0996094C24.8999 0.0996094 23.5999 1.19961 23.0999 2.89961C22.6999 4.49961 22.1999 6.09961 21.7999 7.59961C20.8999 10.8996 19.9999 14.0996 19.2999 17.4996C19.0999 18.3996 19.3999 19.0996 19.6999 19.3996C20.1999 19.9996 20.8999 20.2996 21.7999 20.2996H22.3999C22.3999 29.2996 22.3999 31.9996 22.3999 32.7996V32.8996C22.3999 34.5996 23.9999 35.8996 25.9999 35.8996C27.9999 35.8996 29.5999 34.4996 29.5999 32.8996V3.09961C29.7999 1.29961 28.5999 0.0996094 26.6999 0.0996094ZM24.8999 19.0996V18.2996C24.8999 18.1996 24.8999 18.0996 24.7999 17.9996C24.6999 17.8996 24.5999 17.8996 24.4999 17.8996H22.7999H21.8999C21.7999 17.8996 21.7999 17.8996 21.6999 17.8996C22.3999 14.4996 23.2999 11.3996 24.1999 8.19961C24.5999 6.79961 24.9999 5.09961 25.4999 3.49961C25.5999 3.09961 25.8999 2.49961 26.6999 2.49961C27.1999 2.49961 27.3999 2.59961 27.3999 3.09961V32.7996C27.3999 32.9996 26.9999 33.3996 26.1999 33.3996C25.3999 33.3996 24.9999 32.9996 24.9999 32.7996V32.5996C24.8999 29.1996 24.8999 21.0996 24.8999 19.0996Z"
      fill={props.color || '#009AF8'}
    />
    <path
      d="M17.3 0.798828H15.7C15.5 0.798828 15.3 0.998828 15.3 1.19883V9.39883C15.3 10.0988 14.8 10.7988 13.8 11.1988L13.3 11.3988C13.2 11.4988 13.1 11.5988 13.1 11.7988V32.7988C13.1 32.9988 12.6 33.3988 11.9 33.3988C11.2 33.3988 10.7 32.9988 10.7 32.7988V11.7988C10.7 11.5988 10.6 11.4988 10.5 11.3988L9.99995 11.1988C9.09995 10.7988 8.49995 10.0988 8.49995 9.39883V1.19883C8.49995 0.998828 8.29995 0.798828 8.09995 0.798828H6.59995C6.39995 0.798828 6.19995 0.998828 6.19995 1.19883V9.39883C6.19995 10.7988 6.99995 12.0988 8.29995 12.9988V32.7988C8.29995 34.4988 9.89995 35.7988 11.9 35.7988C13 35.7988 14 35.3988 14.6 34.6988C15.1 34.1988 15.4 33.4988 15.4 32.7988V12.9988C16.8 12.0988 17.5 10.7988 17.5 9.39883V1.19883C17.7 0.998828 17.5 0.798828 17.3 0.798828Z"
      fill={props.color || '#009AF8'}
    />
    <path
      d="M11.2 7.79883H12.8C13 7.79883 13.2 7.59883 13.2 7.39883V1.19883C13.2 0.998828 13 0.798828 12.8 0.798828H11.2C11 0.798828 10.8 0.998828 10.8 1.19883V7.29883C10.8 7.59883 10.9 7.79883 11.2 7.79883Z"
      fill={props.color || '#009AF8'}
    />
  </svg>
)

export const ShoppingBag = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1111 3.06755V1.77865C11.1111 1.04227 10.5142 0.445312 9.77777 0.445312H6.22222C5.48584 0.445312 4.88889 1.04227 4.88889 1.77865V3.06755H0.399994V13.7787C0.399994 14.785 1.21583 15.6009 2.22222 15.6009H11.5555H13.7778C14.7842 15.6009 15.6 14.785 15.6 13.7787V3.06755H13.3778H11.1111ZM10.2222 3.06755V1.77865C10.2222 1.53319 10.0232 1.3342 9.77777 1.3342L6.22222 1.3342C5.97676 1.3342 5.77777 1.53319 5.77777 1.77865V3.06755H10.2222ZM13.7778 14.6231H13.1707C13.303 14.3707 13.3778 14.0834 13.3778 13.7787V4.04532H14.6222V13.7787C14.6222 14.245 14.2441 14.6231 13.7778 14.6231ZM1.37777 4.04532H12.4V13.7787C12.4 14.245 12.0219 14.6231 11.5555 14.6231H2.22222C1.75584 14.6231 1.37777 14.245 1.37777 13.7787V4.04532Z"
      fill={props.color || '#41494F'}
    />
  </svg>
)

export const Smartphone = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1556 16H4.84445C4.00001 16 3.33334 15.3333 3.33334 14.4889V1.51111C3.33334 0.666667 4.00001 0 4.84445 0H11.1556C12 0 12.6667 0.666667 12.6667 1.51111V14.5333C12.6667 15.3333 12 16 11.1556 16ZM4.84445 1.06667C4.62223 1.06667 4.40001 1.24444 4.40001 1.51111V14.5333C4.40001 14.7556 4.57779 14.9778 4.84445 14.9778H11.1556C11.3778 14.9778 11.6 14.8 11.6 14.5333V1.51111C11.6 1.28889 11.4222 1.06667 11.1556 1.06667H4.84445Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M8.75558 3.06667H7.20002C6.88891 3.06667 6.66669 2.84444 6.66669 2.53333C6.66669 2.22222 6.88891 2 7.20002 2H8.75558C9.06669 2 9.28891 2.22222 9.28891 2.53333C9.28891 2.84444 9.06669 3.06667 8.75558 3.06667Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M8.00001 14.0883C8.44184 14.0883 8.80001 13.7301 8.80001 13.2883C8.80001 12.8465 8.44184 12.4883 8.00001 12.4883C7.55818 12.4883 7.20001 12.8465 7.20001 13.2883C7.20001 13.7301 7.55818 14.0883 8.00001 14.0883Z"
      fill={props.color || '#41494F'}
    />
  </svg>
)

export const Culture = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5333 11.9556C9.77778 13.6889 8.13334 14.9333 6.17778 14.9333C3.55556 14.9333 1.42223 12.7111 1.42223 10V5.06667H10.9778V10C10.9778 10.3111 10.9333 10.5778 10.8889 10.8444C10.8444 11.0222 10.8 11.2 10.7556 11.4222C10.7111 11.6 10.6222 11.7778 10.5333 11.9556ZM14.8444 6C14.8444 8 13.6444 9.73333 12 10.5333C12 10.3556 12.0444 10.1778 12.0444 10V4H5.28889V1.06667H14.8444V6ZM4.22223 0V4H0.35556V10C0.35556 13.3333 2.97778 16 6.17778 16C8.8 16 11.0222 14.2222 11.7333 11.7333C14.1333 10.9778 15.8667 8.71111 15.8667 6V0H4.22223Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M8.13333 8.48976C7.86667 8.48976 7.68889 8.26753 7.68889 8.00087C7.68889 7.7342 7.91111 7.51198 8.13333 7.51198C8.35556 7.51198 8.57778 7.7342 8.57778 8.00087C8.57778 8.26753 8.35556 8.48976 8.13333 8.48976ZM8.13333 6.44531C7.28889 6.44531 6.62222 7.15642 6.62222 8.00087C6.62222 8.84531 7.28889 9.55642 8.13333 9.55642C8.97778 9.55642 9.64445 8.84531 9.64445 8.00087C9.6 7.15642 8.93333 6.44531 8.13333 6.44531Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M4.22223 7.51293C4.31112 7.51293 4.35556 7.55738 4.44445 7.55738C4.57779 7.64627 4.71112 7.7796 4.71112 7.95738C4.71112 8.04627 4.71112 8.09071 4.66668 8.1796C4.57779 8.35738 4.44445 8.44627 4.26668 8.44627C4.00001 8.44627 3.82223 8.22405 3.82223 7.95738C3.77779 7.73516 4.00001 7.51293 4.22223 7.51293ZM4.22223 9.55738C4.57779 9.55738 4.8889 9.42405 5.11112 9.24627C5.24445 9.11293 5.37779 8.9796 5.46668 8.84627C5.60001 8.62405 5.6889 8.40182 5.6889 8.13516C5.6889 8.09071 5.6889 8.09071 5.6889 8.04627C5.6889 7.64627 5.55556 7.33516 5.33334 7.06849C5.15557 6.89071 4.97779 6.71293 4.75556 6.62405C4.57779 6.5796 4.40001 6.53516 4.22223 6.53516C3.37779 6.53516 2.71112 7.24627 2.71112 8.09071C2.75557 8.84627 3.42223 9.55738 4.22223 9.55738Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M6.17779 12.4448C5.46667 12.4448 4.84445 12.1337 4.40001 11.6448H7.91112C7.51112 12.1337 6.8889 12.4448 6.17779 12.4448ZM7.15556 10.5781H2.84445C3.11112 12.267 4.53334 13.5115 6.22223 13.5115C7.42223 13.5115 8.4889 12.8448 9.06667 11.9115C9.15556 11.7337 9.24445 11.6003 9.33334 11.4226C9.42223 11.2448 9.46667 11.067 9.51112 10.8892C9.55556 10.8003 9.55556 10.667 9.60001 10.5781H7.15556Z"
      fill={props.color || '#41494F'}
    />
  </svg>
)

export const Gastronomy = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7334 12.5768H9.6667C9.84448 12.1324 9.97781 11.6435 10.0223 11.1546C10.2889 10.9324 10.4223 10.5768 10.4223 10.1324V9.46571C10.4223 8.84349 10.2 8.53238 9.88892 8.39905V7.77682C9.88892 7.73238 9.88892 7.64349 9.88892 7.59905C9.88892 7.59905 9.88892 7.59905 9.88892 7.5546V5.19905H10.3778C11.0889 5.19905 11.5778 4.48793 11.5778 3.86571C11.5778 1.73238 9.84448 -0.0898438 7.75559 -0.0898438H7.08892C6.24448 -0.0898438 5.53337 0.487934 5.31114 1.28793C4.15559 1.51016 3.2667 2.53238 3.2667 3.77682C3.2667 4.26571 3.57781 4.88793 4.0667 5.11016V7.5546C4.0667 7.5546 4.0667 7.5546 4.0667 7.59905C4.0667 7.64349 4.0667 7.68793 4.0667 7.77682V8.44349C3.75559 8.57682 3.53337 8.88793 3.53337 9.51016V10.1768C3.53337 10.5768 3.75559 10.9768 4.0667 11.199C4.11114 11.6879 4.24448 12.1324 4.42225 12.5768H3.75559C2.42225 12.5768 0.866699 13.6879 0.866699 15.0657V15.4657C0.955588 15.7768 1.22225 15.999 1.48892 15.999C1.75559 15.999 2.02225 15.7768 2.02225 15.4657V15.0657C2.02225 14.3102 3.04448 13.6435 3.84448 13.6435H5.17781C5.71114 14.2213 6.37781 14.6213 7.13337 14.6213C7.88892 14.6213 8.55559 14.2213 9.04448 13.6435H9.08892H10.7334C11.5778 13.6435 11.9778 14.399 11.9778 15.0657V15.4657C11.9778 15.7768 12.2 15.999 12.5111 15.999C12.8223 15.999 13.0445 15.7768 13.0445 15.4657V15.0657C13.0445 13.6435 12.0667 12.5768 10.7334 12.5768ZM5.80003 2.39905C6.11114 2.39905 6.33337 2.17682 6.33337 1.86571C6.33337 1.42127 6.68892 1.06571 7.08892 1.06571H7.75559C9.22226 1.06571 10.5111 2.39904 10.5111 3.9546C10.5111 4.04349 10.4223 4.17682 10.3778 4.22127H9.35559C9.04448 4.22127 8.82226 4.44349 8.82226 4.7546V6.3546C8.68892 6.3546 8.55559 6.3546 8.42226 6.3546H5.80003C5.57781 6.3546 5.35559 6.3546 5.17781 6.39905V4.79905C5.17781 4.48793 4.95559 4.26571 4.64448 4.26571H4.55559C4.51114 4.22127 4.37781 4.04349 4.37781 3.91016C4.37781 3.02127 5.04448 2.39905 5.80003 2.39905ZM7.13337 13.5546C6.0667 13.5546 5.17781 12.0435 5.17781 10.799C5.17781 10.5324 4.95559 10.3102 4.68892 10.2657C4.64448 10.2213 4.64448 10.1768 4.64448 10.1324V9.46571C4.64448 9.42127 4.64448 9.37682 4.64448 9.33238C4.95559 9.33238 5.17781 9.11016 5.17781 8.79905V7.73238C5.17781 7.42127 5.22225 7.33238 5.22225 7.33238C5.2667 7.28793 5.35559 7.28793 5.80003 7.28793H8.42226C8.60003 7.28793 8.73337 7.28793 8.77781 7.28793C8.77781 7.42127 8.77781 7.64349 8.77781 7.73238V8.79905C8.77781 9.11016 9.00003 9.33238 9.31114 9.33238C9.31114 9.37682 9.31114 9.42127 9.31114 9.46571V10.1324C9.31114 10.1768 9.31114 10.2213 9.31114 10.2657C9.08892 10.3102 8.91114 10.5324 8.91114 10.799C8.95559 12.0879 8.15559 13.5546 7.13337 13.5546Z"
      fill={props.color || '#EC008C'}
    />
  </svg>
)

export const Plane = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7333 0C13.1111 0 12.5777 0.222222 12.1333 0.666667L9.64442 3.33333L2.97775 1.28889C2.84442 1.28889 2.71108 1.24444 2.57775 1.24444C2.2222 1.24444 1.86664 1.37778 1.59997 1.64444L0.222196 3.02222C0.0444179 3.2 -0.044471 3.46667 -2.65865e-05 3.73333C0.0444178 4 0.222196 4.22222 0.444418 4.35556L6.35553 7.28889L3.91108 10.9778L2.48886 10.5333C2.39997 10.4889 2.31108 10.4889 2.2222 10.4889C1.99997 10.4889 1.77775 10.5778 1.59997 10.7556C1.4222 10.9333 1.33331 11.2 1.37775 11.5111C1.4222 11.7778 1.59997 12 1.8222 12.1333L3.11108 12.7556L3.77775 14.0444C3.91108 14.3556 4.22219 14.5333 4.53331 14.5333C4.75553 14.5333 4.97775 14.4444 5.11108 14.2667C5.33331 14.0444 5.42219 13.7333 5.33331 13.4222L4.88886 12L8.57775 9.55556L11.6444 15.5556C11.7777 15.8667 12.0889 16.0444 12.4 16.0444C12.6222 16.0444 12.8444 15.9556 13.0222 15.7778L14.4 14.4C14.7555 14.0444 14.8889 13.5111 14.7555 13.0222L12.7111 6.35556L15.4222 3.82222C16.3111 2.93333 16.3111 1.51111 15.4222 0.622222C14.9333 0.222222 14.3555 0 13.7333 0ZM9.06664 8.08889L5.64442 10.3556L7.91108 6.93333L1.19997 3.55556L2.35553 2.4C2.39997 2.35556 2.48886 2.31111 2.57775 2.31111C2.6222 2.31111 2.6222 2.31111 2.66664 2.31111L9.99997 4.53333L12.9333 1.37778C13.1555 1.15556 13.4666 1.02222 13.7777 1.02222C14.0889 1.02222 14.4 1.15556 14.6222 1.37778C15.0666 1.82222 15.0666 2.57778 14.6222 3.06667L11.4666 6.04444L13.6889 13.3333C13.7333 13.4222 13.6889 13.5556 13.6 13.6444L12.4444 14.8L9.06664 8.08889Z"
      fill={props.color || '#41494F'}
    />
  </svg>
)

export const PetPaw = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M5.15553 5.19922C3.73331 5.19922 2.31109 5.73255 1.19998 6.84366C-0.977802 9.02144 0.04442 11.5548 2.2222 13.777C3.55553 15.1103 5.0222 15.9992 6.44442 15.9992C7.37775 15.9992 8.26664 15.6437 9.11109 14.7992C11.2889 12.6214 11.2889 9.06589 9.11109 6.88811C8.04442 5.73255 6.6222 5.19922 5.15553 5.19922ZM5.15553 6.26589C6.35553 6.26589 7.51109 6.75477 8.35553 7.59922C10.1333 9.377 10.1333 12.2659 8.35553 14.0437C7.73331 14.6659 7.11109 14.9326 6.44442 14.9326C5.4222 14.9326 4.2222 14.2659 2.97775 13.0214C-0.222247 9.82144 1.4222 8.177 1.95553 7.59922C2.84442 6.75477 3.95553 6.26589 5.15553 6.26589Z"
        fill={props.color || '#41494F'}
      />
      <path
        d="M11.6 2.26562C11.0667 2.26562 10.5333 2.48785 10.1333 2.88785C9.33333 3.68785 9.33333 5.02118 10.1333 5.86563C10.5333 6.26562 11.0667 6.48785 11.6 6.48785C12.1333 6.48785 12.6667 6.26562 13.0667 5.86563C13.8667 5.06563 13.8667 3.73229 13.0667 2.88785C12.6667 2.48785 12.1333 2.26562 11.6 2.26562ZM11.6 3.33229C11.8667 3.33229 12.1333 3.42118 12.3111 3.6434C12.4889 3.82118 12.6222 4.08785 12.6222 4.35451C12.6222 4.62118 12.5333 4.88785 12.3111 5.06562C12.1333 5.2434 11.8667 5.37674 11.6 5.37674C11.3333 5.37674 11.0667 5.28785 10.8889 5.06562C10.7111 4.88785 10.5778 4.62118 10.5778 4.35451C10.5778 4.08785 10.6667 3.82118 10.8889 3.6434C11.0667 3.42118 11.3333 3.33229 11.6 3.33229Z"
        fill={props.color || '#41494F'}
      />
      <path
        d="M6.35555 0C5.82221 0 5.28888 0.222222 4.88888 0.622222C4.08888 1.42222 4.08888 2.75556 4.88888 3.6C5.28888 4 5.82221 4.22222 6.35555 4.22222C6.88888 4.22222 7.42221 4 7.82221 3.6C8.62221 2.8 8.62221 1.46667 7.82221 0.622222C7.46666 0.222222 6.93332 0 6.35555 0ZM6.35555 1.06667C6.62221 1.06667 6.88888 1.15556 7.06666 1.37778C7.24444 1.55556 7.37777 1.82222 7.37777 2.08889C7.37777 2.35556 7.28888 2.62222 7.1111 2.84444C6.93332 3.02222 6.66666 3.15556 6.39999 3.15556C6.13332 3.15556 5.86666 3.06667 5.68888 2.84444C5.5111 2.66667 5.37777 2.4 5.37777 2.13333C5.37777 1.86667 5.46666 1.6 5.68888 1.42222C5.82221 1.15556 6.08888 1.06667 6.35555 1.06667Z"
        fill={props.color || '#41494F'}
      />
      <path
        d="M13.9111 7.55469C13.3778 7.55469 12.8444 7.77691 12.4444 8.17691C11.6444 8.97691 11.6444 10.3102 12.4444 11.1547C12.8444 11.5547 13.3778 11.7769 13.9111 11.7769C14.4444 11.7769 14.9778 11.5547 15.3778 11.1547C16.1778 10.3547 16.1778 9.02135 15.3778 8.17691C14.9778 7.73247 14.4444 7.55469 13.9111 7.55469ZM13.9111 8.62135C14.1778 8.62135 14.4444 8.71024 14.6222 8.93247C14.8 9.11024 14.9333 9.37691 14.9333 9.64358C14.9333 9.91024 14.8444 10.1769 14.6222 10.3547C14.4444 10.5325 14.1778 10.6658 13.9111 10.6658C13.6444 10.6658 13.3778 10.5769 13.2 10.3547C13.0222 10.1769 12.8889 9.91024 12.8889 9.64358C12.8889 9.37691 12.9778 9.11024 13.2 8.93247C13.3778 8.71024 13.6444 8.62135 13.9111 8.62135Z"
        fill={props.color || '#41494F'}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const WeightGym = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8444 1.60156H13.6889C13.7778 1.60156 13.8667 1.69045 13.8667 1.77934V3.82378C13.8667 3.91267 13.9556 4.00156 14.0444 4.00156H15.8222C15.9111 4.00156 16 4.09045 16 4.17934V11.8238C16 11.9127 15.9111 12.0016 15.8222 12.0016H14.0444C13.9556 12.0016 13.8667 12.0904 13.8667 12.1793V14.2238C13.8667 14.3127 13.7778 14.4016 13.6889 14.4016H10.8444C10.7556 14.4016 10.6667 14.3127 10.6667 14.2238V8.71267C10.6667 8.62378 10.5778 8.53489 10.4889 8.53489H5.51111C5.42222 8.53489 5.33333 8.62378 5.33333 8.71267V14.2238C5.33333 14.3127 5.24444 14.4016 5.15556 14.4016H2.31111C2.22222 14.4016 2.13333 14.3127 2.13333 14.2238V12.1793C2.13333 12.0904 2.04444 12.0016 1.95556 12.0016H0.177778C0.0888889 12.0016 0 11.9127 0 11.8238V4.17934C0 4.09045 0.0888889 4.00156 0.177778 4.00156H1.95556C2.04444 4.00156 2.13333 3.91267 2.13333 3.82378V1.77934C2.13333 1.69045 2.22222 1.60156 2.31111 1.60156H5.15556C5.24444 1.60156 5.33333 1.69045 5.33333 1.77934V7.29045C5.33333 7.37934 5.42222 7.46823 5.51111 7.46823H10.4889C10.5778 7.46823 10.6667 7.37934 10.6667 7.29045V1.77934C10.6667 1.69045 10.7556 1.60156 10.8444 1.60156ZM11.9111 13.3349H12.6222C12.7111 13.3349 12.8 13.246 12.8 13.1571V2.84601C12.8 2.75712 12.7111 2.66823 12.6222 2.66823H11.9111C11.8222 2.66823 11.7333 2.75712 11.7333 2.84601V13.1571C11.7333 13.246 11.8222 13.3349 11.9111 13.3349ZM3.37778 13.3349H4.08889C4.17778 13.3349 4.26667 13.246 4.26667 13.1571V2.84601C4.26667 2.75712 4.17778 2.66823 4.08889 2.66823H3.37778C3.28889 2.66823 3.2 2.75712 3.2 2.84601V13.1571C3.2 13.246 3.28889 13.3349 3.37778 13.3349ZM14.0444 10.9349H14.7556C14.8444 10.9349 14.9333 10.846 14.9333 10.7571V5.24601C14.9333 5.15712 14.8444 5.06823 14.7556 5.06823H14.0444C13.9556 5.06823 13.8667 5.15712 13.8667 5.24601V10.7571C13.8667 10.846 13.9556 10.9349 14.0444 10.9349ZM1.24444 10.9349H1.95556C2.04444 10.9349 2.13333 10.846 2.13333 10.7571V5.24601C2.13333 5.15712 2.04444 5.06823 1.95556 5.06823H1.24444C1.15556 5.06823 1.06667 5.15712 1.06667 5.24601V10.7571C1.06667 10.846 1.15556 10.9349 1.24444 10.9349Z"
      fill={props.color || '#41494F'}
    />
  </svg>
)

export const CarDoorWindow = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.17778 0H15.5556C15.8222 0 16 0.177778 16 0.444444V15.5556C16 15.8222 15.8222 16 15.5556 16H0.444444C0.177778 16 0 15.8222 0 15.5556V8.17778C0 8.04444 0.0444444 7.95556 0.133333 7.86667L7.86667 0.133333C7.95556 0.0444444 8.08889 0 8.17778 0ZM8.31111 1.2L2.8 6.71111C2.53333 6.97778 2.71111 7.46667 3.11111 7.46667H14.4889C14.7556 7.46667 14.9333 7.28889 14.9333 7.02222V1.51111C14.9333 1.24444 14.7556 1.06667 14.4889 1.06667H8.62222C8.48889 1.06667 8.4 1.11111 8.31111 1.2ZM1.51111 14.9333H14.4889C14.7556 14.9333 14.9333 14.7556 14.9333 14.4889V8.97778C14.9333 8.71111 14.7556 8.53333 14.4889 8.53333H1.51111C1.24444 8.53333 1.06667 8.71111 1.06667 8.97778V14.4889C1.06667 14.7556 1.24444 14.9333 1.51111 14.9333Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M8.53334 11.4667V11.0667H11.4667V11.4667H8.53334ZM8.35556 12.5333H11.6445C12.1333 12.5333 12.5333 12.1333 12.5333 11.6444V10.8889C12.5333 10.4 12.1333 10 11.6445 10H8.35556C7.86667 10 7.46667 10.4 7.46667 10.8889V11.6444C7.46667 12.1333 7.86667 12.5333 8.35556 12.5333Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M7.95554 5.55694L10.3555 3.15694C10.5333 2.97917 10.5333 2.7125 10.3555 2.53472L10.2222 2.44583C10.0444 2.26806 9.77776 2.26806 9.59998 2.44583L7.19998 4.84583C7.02221 5.02361 7.02221 5.29028 7.19998 5.46806L7.33332 5.60139C7.51109 5.73472 7.77776 5.73472 7.95554 5.55694Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M10.4 6.44583L11.6444 5.20139C11.8222 5.02361 11.8222 4.75694 11.6444 4.57917L11.5111 4.44583C11.3333 4.26806 11.0667 4.26806 10.8889 4.44583L9.64444 5.69028C9.46666 5.86806 9.46666 6.13472 9.64444 6.3125L9.77777 6.44583C9.95555 6.62361 10.2222 6.62361 10.4 6.44583Z"
      fill={props.color || '#41494F'}
    />
  </svg>
)

export const Time = (props) => (
  <svg
    width={props.width || '36'}
    height={props.height || '36'}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2004 5.8V2.4H25.1004C25.8004 2.4 26.3004 1.9 26.3004 1.2C26.3004 0.5 25.7004 0 25.1004 0H10.9004C10.2004 0 9.70039 0.5 9.70039 1.2C9.70039 1.9 10.2004 2.4 10.9004 2.4H16.8004V5.7C16.8004 5.7 16.8004 5.7 16.8004 5.8C9.00039 6.4 2.90039 12.9 2.90039 20.8C2.90039 29.1 9.60039 35.9 18.0004 35.9C26.4004 35.9 33.1004 29.2 33.1004 20.8C33.1004 12.9 26.9004 6.4 19.2004 5.8ZM18.0004 33.5C11.0004 33.5 5.30039 27.8 5.30039 20.8C5.30039 13.8 11.0004 8.1 18.0004 8.1C25.0004 8.1 30.7004 13.8 30.7004 20.8C30.7004 27.8 25.0004 33.5 18.0004 33.5Z"
      fill={props.color || '#41494F'}
    />
    <path
      d="M24.4008 19.6H19.2008V14.4C19.2008 13.7 18.7008 13.2 18.0008 13.2C17.3008 13.2 16.8008 13.7 16.8008 14.4V20.8C16.8008 21.5 17.3008 22 18.0008 22H24.4008C25.1008 22 25.6008 21.5 25.6008 20.8C25.6008 20.1 25.1008 19.6 24.4008 19.6Z"
      fill={props.color || '#41494F'}
    />
  </svg>
)

export const Star = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.3997 34.8C28.0997 34.8 27.8997 34.7 27.6997 34.6L17.9997 27.4L8.2997 34.4C7.8997 34.7 7.2997 34.7 6.8997 34.4C6.4997 34.1 6.2997 33.5 6.4997 33.1L10.1997 22.2L0.599702 15.6C0.199702 15.3 -0.000297852 14.8 0.0997021 14.3C0.299702 13.8 0.699702 13.5 1.1997 13.5H13.1997L16.8997 2.00001C16.9997 1.50001 17.4997 1.20001 17.9997 1.20001C18.4997 1.20001 18.9997 1.50001 19.0997 2.00001L22.7997 13.4H34.7997C35.2997 13.4 35.7997 13.7 35.8997 14.2C36.0997 14.7 35.8997 15.2 35.3997 15.5L25.7997 22L29.4997 33.1C29.6997 33.6 29.4997 34.1 29.0997 34.4C28.8997 34.7 28.5997 34.8 28.3997 34.8ZM17.9997 24.7C18.2997 24.7 18.4997 24.8 18.6997 24.9L25.9997 30.3L23.2997 22C23.0997 21.5 23.2997 20.9 23.7997 20.6L30.9997 15.7H21.9997C21.4997 15.7 20.9997 15.4 20.8997 14.9L17.9997 6.30001L15.1997 15C14.9997 15.5 14.5997 15.8 14.0997 15.8H5.0997L12.2997 20.7C12.6997 21 12.8997 21.6 12.7997 22.1L9.9997 30.3L17.2997 25C17.4997 24.8 17.7997 24.7 17.9997 24.7Z"
      fill={props.color || '#41494F'}
    />
  </svg>
)

export const Ticket = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="#EC008C" />
    <path
      d="M17.8001 24H15.6001C15.1335 24 14.8001 23.6667 14.8001 23.2C14.8001 23.1333 14.8001 23.1333 14.8001 23.0667C14.8001 23 14.8001 22.9333 14.8001 22.8667C14.8001 21.4 13.6001 20.1333 12.1335 20.1333C10.6668 20.1333 9.46681 21.3333 9.46681 22.8C9.46681 22.8667 9.46681 22.9333 9.46681 23C9.46681 23.0667 9.46681 23.0667 9.46681 23.1333C9.46681 23.6 9.13348 23.9333 8.66681 23.9333H6.20015C5.73348 23.9333 5.40015 23.6 5.40015 23.1333V0.8C5.40015 0.333333 5.73348 0 6.20015 0H8.73348C9.20015 0 9.53348 0.333333 9.53348 0.8C9.53348 2.26667 10.7335 3.46667 12.2001 3.46667C13.6668 3.46667 14.8668 2.26667 14.8668 0.8C14.8668 0.333333 15.2001 0 15.6668 0H17.8668C18.3335 0 18.6668 0.333333 18.6668 0.8V23.2C18.6001 23.6667 18.2668 24 17.8001 24ZM16.4001 22.4H17.0001V1.6H16.3335C15.9335 3.53333 14.2668 5.06667 12.2001 5.06667C10.1335 5.06667 8.40015 3.53333 8.00015 1.6H7.00015V22.4H8.00015C8.20015 20.2667 10.0001 18.6 12.2001 18.6C14.3335 18.6 16.1335 20.2667 16.4001 22.4Z"
      fill={props.color || '#FFFFFF'}
    />
    <path
      d="M9.26675 9.33242H8.46675C8.00008 9.33242 7.66675 8.99909 7.66675 8.53242C7.66675 8.06576 8.00008 7.73242 8.46675 7.73242H9.26675C9.73341 7.73242 10.0667 8.06576 10.0667 8.53242C10.0667 8.99909 9.73341 9.33242 9.26675 9.33242Z"
      fill={props.color || '#FFFFFF'}
    />
    <path
      d="M13.9333 9.33242H13.1333C12.6666 9.33242 12.3333 8.99909 12.3333 8.53242C12.3333 8.06576 12.6666 7.73242 13.1333 7.73242H13.9333C14.3999 7.73242 14.7333 8.06576 14.7333 8.53242C14.7333 8.99909 14.3999 9.33242 13.9333 9.33242Z"
      fill={props.color || '#FFFFFF'}
    />
    <path
      d="M10.6669 16.266H9.86689C9.40023 16.266 9.06689 15.9327 9.06689 15.466C9.06689 14.9993 9.40023 14.666 9.86689 14.666H10.6669C11.1336 14.666 11.4669 14.9993 11.4669 15.466C11.4669 15.9327 11.1336 16.266 10.6669 16.266Z"
      fill={props.color || '#FFFFFF'}
    />
    <path
      d="M15.2667 16.266H14.4667C14.0001 16.266 13.6667 15.9327 13.6667 15.466C13.6667 14.9993 14.0001 14.666 14.4667 14.666H15.2667C15.7334 14.666 16.0667 14.9993 16.0667 15.466C16.0667 15.9327 15.7334 16.266 15.2667 16.266Z"
      fill={props.color || '#FFFFFF'}
    />
  </svg>
)

export const Environmental = (props) => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1169 15.0127C19.3225 15.0127 19.528 15.0127 19.7336 15.0127C20.453 16.4127 21.378 19.4127 21.378 20.6127C21.378 21.3127 21.8919 21.8127 22.6113 21.8127C23.3308 21.8127 23.8447 21.3127 23.8447 20.6127C23.8447 19.7127 25.5919 18.0127 27.2363 16.9127C27.3391 16.9127 27.5447 16.9127 27.6475 16.9127C30.4225 16.9127 32.1697 15.8127 33.1975 14.8127C34.8419 13.2127 35.6641 10.9127 35.3558 8.51274C35.253 7.91274 34.7391 7.41274 34.0197 7.41274C31.1419 7.51274 28.6752 8.61274 27.2363 10.3127C26.1058 11.6127 25.4891 13.3127 25.4891 15.1127C24.8725 15.6127 23.9475 16.3127 23.0225 17.2127C22.6113 15.8127 21.9947 14.3127 21.4808 13.4127C21.6863 10.3127 20.7613 7.51274 18.9113 5.41274C16.5475 2.81274 12.8475 1.21274 8.32524 1.01274C7.81135 0.912742 7.29746 1.41274 7.19468 2.11274C6.78357 5.81274 8.11968 9.41274 10.5863 11.8127C12.128 13.3127 14.8002 15.0127 19.1169 15.0127ZM29.1891 11.9127C30.0113 10.9127 31.3475 10.3127 32.9919 10.0127C32.8891 11.2127 32.3752 12.3127 31.553 13.2127C30.7308 14.0127 29.4975 14.5127 28.1613 14.6127C28.1613 13.5127 28.5725 12.6127 29.1891 11.9127ZM17.1641 7.01274C18.5002 8.51274 19.2197 10.5127 19.2197 12.7127C16.4447 12.7127 13.978 11.9127 12.3336 10.2127C10.5863 8.51274 9.66135 6.11274 9.66135 3.61274C12.8475 3.91274 15.5197 5.11274 17.1641 7.01274Z"
      fill={props.color || '#8B8B8B'}
    />
    <path
      d="M33.3 22.7121C32.1694 22.7121 31.0389 23.6121 29.7028 24.8121C28.9833 25.4121 27.6472 26.4121 26.7222 26.9121C26.6194 26.3121 26.3111 25.9121 26.0028 25.6121C24.4611 23.9121 21.275 23.8121 19.6306 23.9121C19.425 23.9121 18.9111 23.6121 18.3972 23.3121C16.9583 22.4121 14.8 21.1121 10.6889 20.8121V19.1121C10.6889 18.4121 10.175 17.9121 9.45556 17.9121H1.23333C0.513889 17.9121 0 18.4121 0 19.1121V31.8121C0 32.5121 0.513889 33.0121 1.23333 33.0121H9.55833C10.2778 33.0121 10.7917 32.5121 10.7917 31.8121V31.7121C11.5111 32.0121 12.3333 32.3121 13.0528 32.7121C15.6222 33.9121 18.8083 35.4121 21.4806 35.4121C25.3861 35.4121 37.1028 30.2121 37.1028 26.6121C37 24.2121 35.5611 22.7121 33.3 22.7121ZM8.325 30.5121H2.46667V20.2121H8.325V30.5121ZM21.3778 32.8121C19.3222 32.8121 16.3417 31.5121 13.9778 30.4121C12.5389 29.7121 11.5111 29.3121 10.6889 29.0121V23.1121C14.0806 23.3121 15.8278 24.4121 17.0611 25.2121C17.8833 25.7121 18.7056 26.2121 19.7333 26.2121C20.5556 26.2121 23.125 26.2121 23.9472 27.0121H17.4722C16.7528 27.0121 16.2389 27.5121 16.2389 28.2121C16.2389 28.9121 16.7528 29.4121 17.4722 29.4121H25.3861C27.3389 29.7121 29.2917 28.1121 31.1417 26.6121C31.8611 26.0121 32.8889 25.2121 33.1972 25.1121C34.0194 25.1121 34.4306 25.3121 34.4306 26.4121C34.1222 28.0121 25.3861 32.8121 21.3778 32.8121Z"
      fill={props.color || '#8B8B8B'}
    />
  </svg>
)

export const Printer = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0005 6.2H22.0671C22.4671 6.2 22.8671 6.53333 22.8671 7V15.4667C22.8671 15.9333 22.5338 16.2667 22.0671 16.2667H18.2005V23.2C18.2005 23.6667 17.8671 24 17.4005 24H10.3338C10.1338 24 9.93379 23.9333 9.80046 23.8L6.06712 20.7333C5.93379 20.6 5.80046 20.4 5.80046 20.1333V16.2667H1.93379C1.46712 16.2667 1.13379 15.9333 1.13379 15.4667V7C1.13379 6.53333 1.46712 6.2 1.93379 6.2H5.00046V0.8C5.00046 0.333333 5.40046 0 5.80046 0H18.2005C18.6671 0 19.0005 0.333333 19.0005 0.8V6.2ZM17.3338 1.6H6.60046V6.2H17.3338V1.6ZM16.5338 22.4H10.8671V20.3333C10.8671 20 10.6005 19.7333 10.2671 19.7333H7.40046L7.33379 19.6667V11.6667H16.5338V22.4ZM18.2005 14.6667H21.2005V7.8H18.1338H5.80046H2.73379V14.6667H5.80046V10.8C5.80046 10.3333 6.13379 10 6.60046 10H17.4005C17.8671 10 18.2005 10.3333 18.2005 10.8V14.6667ZM9.26712 14.7333H14.6671C15.1338 14.7333 15.4671 14.4 15.4671 13.9333C15.4671 13.4667 15.1338 13.1333 14.6671 13.1333H9.26712C8.80046 13.1333 8.46712 13.4667 8.46712 13.9333C8.46712 14.4 8.86712 14.7333 9.26712 14.7333ZM14.6671 17.8H9.26712C8.86712 17.8 8.46712 17.4667 8.46712 17C8.46712 16.5333 8.80046 16.2 9.26712 16.2H14.6671C15.1338 16.2 15.4671 16.5333 15.4671 17C15.4671 17.4667 15.1338 17.8 14.6671 17.8Z"
      fill={props.color || '#FFFFFF'}
    />
  </svg>
)

export const MailSend = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.68108 18.9403H18.4216C19.8486 18.9403 21.0811 17.643 21.4054 16.3457L23.3514 7.13489C23.4811 6.42138 23.3514 5.70787 22.8973 5.18895C22.4432 4.67003 21.8595 4.3457 21.1459 4.3457H9.40541C8.10811 4.3457 6.81081 5.44841 6.48649 6.81057L4.54054 16.0214C4.34595 16.7349 4.54054 17.5133 4.99459 18.0971C5.38378 18.616 6.03243 18.9403 6.68108 18.9403ZM7.97838 7.19976C8.10811 6.55111 8.82162 5.96732 9.40541 5.96732V6.03219H21.2108C21.4703 6.03219 21.6649 6.16192 21.7297 6.29165C21.8595 6.42138 21.9243 6.68084 21.8595 6.9403L19.9135 16.1511C19.7838 16.7998 19.0703 17.4484 18.4865 17.4484H6.74595C6.48649 17.4484 6.29189 17.3187 6.22703 17.1889C6.03243 16.9944 5.96757 16.67 6.03243 16.4106L7.97838 7.19976ZM3.76216 9.59976H0.778378C0.324324 9.59976 0 9.27543 0 8.82138C0 8.36732 0.324324 8.043 0.778378 8.043H3.76216C4.21622 8.043 4.54054 8.36732 4.54054 8.82138C4.54054 9.27543 4.21622 9.59976 3.76216 9.59976ZM3.11351 12.3241H0.778378C0.324324 12.3241 0 11.9998 0 11.5457C0 11.0916 0.324324 10.7673 0.778378 10.7673H3.11351C3.56757 10.7673 3.89189 11.0916 3.89189 11.5457C3.89189 11.9998 3.56757 12.3241 3.11351 12.3241ZM0.778378 14.9835H2.46486C2.85405 14.9835 3.24324 14.6592 3.24324 14.2052C3.24324 13.7511 2.91892 13.4268 2.46486 13.4268H0.778378C0.324324 13.4268 0 13.816 0 14.2052C0 14.5944 0.324324 14.9835 0.778378 14.9835ZM13.8811 14.1403H14.0757C14.7243 14.1403 15.3081 13.8808 15.7622 13.4268L20.7568 8.43219C21.0811 8.10787 21.0811 7.65381 20.7568 7.32949C20.4324 7.00516 19.9784 7.00516 19.6541 7.32949L14.6595 12.3241C14.4649 12.5187 14.2054 12.5835 14.0108 12.5835C13.8162 12.5187 13.5568 12.3889 13.427 12.1944L10.0541 7.39435C9.79459 7.07003 9.27568 6.9403 8.95135 7.19976C8.62703 7.45922 8.4973 7.97814 8.75676 8.30246L12.1297 13.1025C12.5838 13.6862 13.1676 14.0754 13.8811 14.1403Z"
      fill={props.color || '#FFFFFF'}
    />
  </svg>
)
export const Link = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9777 8.3987H4.7555C4.44439 8.3987 4.22217 8.17648 4.22217 7.86536C4.22217 7.55425 4.44439 7.33203 4.7555 7.33203H10.9777C11.2888 7.33203 11.5111 7.55425 11.5111 7.86536C11.5111 8.17648 11.2888 8.3987 10.9777 8.3987Z"
      fill={props.color || '#8B8B8B'}
    />
    <path
      d="M3.77778 11.7782C1.68889 11.7782 0 10.0893 0 8.00043C0 5.91155 1.68889 4.22266 3.77778 4.22266C5.06667 4.22266 6.26667 4.88932 6.97778 6.00043C7.15556 6.2671 7.06667 6.57821 6.8 6.75599C6.53333 6.93377 6.22222 6.84488 6.04444 6.57821C5.55556 5.77821 4.66667 5.28932 3.73333 5.28932C2.22222 5.28932 1.02222 6.48932 1.02222 8.00043C1.02222 9.51154 2.22222 10.7115 3.73333 10.7115C4.71111 10.7115 5.64444 10.1782 6.08889 9.28932C6.22222 9.02266 6.53333 8.93377 6.8 9.0671C7.06667 9.20043 7.15556 9.51154 7.02222 9.77821C6.44444 11.0227 5.15556 11.7782 3.77778 11.7782Z"
      fill={props.color || '#8B8B8B'}
    />
    <path
      d="M12.2225 11.7767C10.8447 11.7767 9.60024 11.0212 8.93357 9.82118C8.80024 9.55451 8.88913 9.2434 9.15579 9.11007C9.42246 8.97674 9.73357 9.06563 9.86691 9.33229C10.3558 10.2212 11.2447 10.7545 12.2225 10.7545C13.7336 10.7545 14.9336 9.55451 14.9336 8.0434C14.9336 6.53229 13.7336 5.33229 12.2225 5.33229C11.2891 5.33229 10.4002 5.82118 9.91135 6.62118C9.73357 6.88785 9.42246 6.93229 9.15579 6.79896C8.88913 6.66563 8.84468 6.31007 8.97802 6.0434C9.68913 4.93229 10.8891 4.26562 12.178 4.26562C14.2669 4.26562 15.9558 5.95451 15.9558 8.0434C15.9558 10.1323 14.3113 11.7767 12.2225 11.7767Z"
      fill={props.color || '#8B8B8B'}
    />
  </svg>
)
export const Secound = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 1.06667C4.17778 1.06667 1.06667 4.17778 1.06667 8C1.06667 11.8222 4.17778 14.9333 8 14.9333C11.8222 14.9333 14.9333 11.8222 14.9333 8C14.9333 4.17778 11.8222 1.06667 8 1.06667Z"
      fill={props.color || '#A5ACB0'}
    />
    <path
      d="M7.6003 8.53385C7.51141 8.53385 7.37807 8.48941 7.28919 8.44496C7.06696 8.26719 6.97807 7.95607 7.15585 7.68941L10.3114 3.3783C10.4892 3.15607 10.8003 3.06719 11.067 3.24496C11.2892 3.42274 11.3781 3.73385 11.2003 4.00052L8.04474 8.31163C7.95585 8.44496 7.77807 8.53385 7.6003 8.53385Z"
      fill={props.color || '#A5ACB0'}
    />
  </svg>
)

export const MaleFemaleSmall = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M11.5563 10.9337L11.2008 9.9115C13.5119 9.37817 14.4452 7.86706 14.7119 7.37817C14.8008 7.20039 14.8008 7.02261 14.7119 6.84483C14.3119 6.17817 13.6452 4.97817 13.5563 4.53372C12.9341 1.95595 11.3786 0.400391 9.33412 0.400391C9.023 0.400391 8.80078 0.622613 8.80078 0.933724C8.80078 1.24483 9.023 1.46706 9.33412 1.46706C11.5119 1.46706 12.2674 3.77817 12.5341 4.75595C12.6674 5.33372 13.3341 6.53372 13.6897 7.1115C13.2897 7.77817 12.0897 9.02261 9.37856 9.02261C9.06745 9.02261 8.84523 9.24483 8.84523 9.55595C8.84523 9.86706 9.06745 10.0893 9.37856 10.0893C9.68967 10.0893 9.95634 10.0893 10.223 10.0448L10.7119 11.5559C10.8008 11.7782 10.9786 11.9115 11.2008 11.9115C12.8008 11.9115 14.9786 13.2004 14.9786 14.4448C14.9786 14.7559 15.2008 14.9782 15.5119 14.9782C15.823 14.9782 16.0452 14.7559 16.0452 14.4448C16.0008 12.5782 13.4675 11.1115 11.5563 10.9337Z"
        fill="#A5ACB0"
      />
      <path
        d="M7.82246 11.4672H7.20023L6.62246 10.5339C7.60023 9.77834 8.35579 8.66722 8.53357 7.55611C8.84468 7.37833 9.02246 7.02278 9.02246 6.53389V5.28945C9.02246 4.88945 8.75579 4.57833 8.53357 4.40056V3.60056C9.11134 2.75611 9.0669 1.82278 8.35579 1.11167C7.42246 0.133891 5.4669 -0.132776 3.73357 1.02278C1.51134 1.06722 0.533567 1.77833 0.533567 3.42278V4.40056C0.311344 4.57833 0.0446777 4.88945 0.0446777 5.28945V6.57834C0.0446777 6.845 0.0446777 7.245 0.400233 7.51167C0.533567 8.66722 1.28912 9.86722 2.2669 10.5783L1.64468 11.4672H0.978011C0.6669 11.4672 0.444678 11.6894 0.444678 12.0006C0.444678 12.3117 0.6669 12.5339 0.978011 12.5339H1.91134C2.08912 12.5339 2.2669 12.445 2.35579 12.3117L3.15579 11.1117C3.55579 11.2894 3.95579 11.3783 4.35579 11.3783C4.80023 11.3783 5.24468 11.2894 5.64468 11.0672L6.40023 12.2672C6.48912 12.445 6.6669 12.5339 6.84468 12.5339H7.77801C8.40023 12.5339 10.3558 12.6672 10.3558 14.5339V15.2006C10.3558 15.5117 10.578 15.7339 10.8891 15.7339C11.2002 15.7339 11.4225 15.5117 11.4225 15.2006V14.5339C11.4225 12.6672 10.0002 11.4672 7.82246 11.4672ZM1.42246 7.11167C1.42246 6.88945 1.28912 6.71167 1.0669 6.62278C1.0669 6.62278 1.0669 6.57834 1.0669 6.53389V5.28945C1.11134 5.245 1.20023 5.15611 1.28912 5.11167C1.4669 5.02278 1.55579 4.845 1.55579 4.66722V3.42278C1.55579 2.80056 1.55579 2.08945 3.8669 2.08945C4.00023 2.08945 4.08912 2.045 4.17801 2.00056C5.55579 0.978335 6.97801 1.33389 7.51134 1.86722C7.8669 2.22278 7.8669 2.66722 7.51134 3.06722C7.42246 3.15611 7.37801 3.28945 7.37801 3.37833V4.62278C7.37801 4.80056 7.4669 4.97833 7.64468 5.06722C7.73357 5.11167 7.82246 5.20056 7.8669 5.245V6.445C7.8669 6.48945 7.8669 6.48945 7.8669 6.53389C7.60023 6.57834 7.42246 6.80056 7.42246 7.06722C7.42246 8.48945 5.73357 10.2228 4.35579 10.2228C3.02246 10.2672 1.42246 8.57833 1.42246 7.11167Z"
        fill="#A5ACB0"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const Download = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.46667 12.2C6.73333 11.8667 7.26667 11.8667 7.6 12.1333L10.8 15V0.8C10.8 0.333333 11.1333 0 11.6 0C12.0667 0 12.4 0.333333 12.4 0.8V15L15.6 12.1333C15.9333 11.8667 16.4667 11.8667 16.7333 12.2C17 12.5333 17 13.0667 16.6667 13.3333L12.1333 17.4C12 17.5333 11.8 17.6 11.6 17.6C11.4 17.6 11.2 17.5333 11.0667 17.4L6.53333 13.3333C6.2 13.0667 6.2 12.5333 6.46667 12.2ZM15.0667 6.53333H23.2C23.6667 6.53333 24 6.93333 24 7.33333V22C24 22.4667 23.6667 22.8 23.2 22.8H0.8C0.333333 22.8 0 22.4667 0 22V7.33333C0 6.93333 0.333333 6.53333 0.8 6.53333H8.13333C8.6 6.53333 8.93333 6.86667 8.93333 7.33333C8.93333 7.8 8.6 8.13333 8.13333 8.13333H1.6V21.2H22.4V8.13333H15.0667C14.6 8.13333 14.2667 7.8 14.2667 7.33333C14.2667 6.86667 14.6 6.53333 15.0667 6.53333Z"
      fill={props.color ? props.color : 'white'}
    />
  </svg>
)

export const Trashcan = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.46667 0H15.5333C15.6667 0 15.8 0.133333 15.8 0.266667V3C15.8 3.13333 15.9333 3.26667 16.0667 3.26667H23.7333C23.8667 3.26667 24 3.4 24 3.53333V7.8C24 7.93333 23.8667 8.06667 23.7333 8.06667H22.6667C22.5333 8.06667 22.4 7.93333 22.4 7.8V5.13333C22.4 5 22.2667 4.86667 22.1333 4.86667H1.86667C1.73333 4.86667 1.6 5 1.6 5.13333V7.8C1.6 7.93333 1.46667 8.06667 1.33333 8.06667H0.266667C0.133333 8.06667 0 7.93333 0 7.8V3.53333C0 3.4 0.133333 3.26667 0.266667 3.26667H7.93333C8.06667 3.26667 8.2 3.13333 8.2 3V0.266667C8.2 0.133333 8.33333 0 8.46667 0ZM10.0667 3.26667H13.9333C14.0667 3.26667 14.2 3.13333 14.2 3V1.86667C14.2 1.73333 14.0667 1.6 13.9333 1.6H10.0667C9.93333 1.6 9.8 1.73333 9.8 1.86667V3C9.8 3.13333 9.93333 3.26667 10.0667 3.26667ZM6.2 22.4H17.8C17.9333 22.4 18.0667 22.2667 18.0667 22.1333L18.8 7.73333C18.8 7.6 18.9333 7.46667 19.0667 7.46667L20.1333 7.53333C20.2667 7.53333 20.4 7.66667 20.4 7.8L19.6 23.7333C19.6 23.8667 19.4667 24 19.3333 24H4.66667C4.53333 24 4.46667 23.8667 4.4 23.7333L3.6 7.8C3.6 7.66667 3.73333 7.53333 3.86667 7.53333L4.93333 7.46667C5.06667 7.46667 5.2 7.6 5.2 7.73333L5.93333 22.1333C5.93333 22.2667 6.06667 22.4 6.2 22.4ZM9.06667 18H10.1333C10.2667 18 10.4 17.8667 10.4 17.7333V7.8C10.4 7.66667 10.2667 7.53333 10.1333 7.53333H9.06667C8.93333 7.53333 8.8 7.66667 8.8 7.8V17.7333C8.8 17.8667 8.93333 18 9.06667 18ZM14.9333 18H13.8667C13.7333 18 13.6 17.8667 13.6 17.7333V7.8C13.6 7.66667 13.7333 7.53333 13.8667 7.53333H14.9333C15.0667 7.53333 15.2 7.66667 15.2 7.8V17.7333C15.2 17.8667 15.0667 18 14.9333 18Z"
      fill={props.color ? props.color : 'white'}
    />
  </svg>
)

export const Youtube = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36 17.4C36 14.4 35.6 11.4 34.9 8.39999C34.3 6.19999 31.9 3.89999 29.6 3.39999C25.8 2.69999 21.9 2.29999 18.1 2.29999H18H17.9C14.1 2.29999 10.2 2.69999 6.4 3.39999C4.2 3.89999 1.7 6.19999 1.1 8.39999C0.5 11.2 0.1 14.1 0 17C0 17.7 0 18.4 0 19C0.1 21.9 0.4 24.8 1.1 27.6C1.7 29.8 4.1 32.2 6.4 32.6C10.2 33.3 14.1 33.7 18 33.7C21.8 33.7 25.7 33.3 29.6 32.6C31.8 32.1 34.3 29.8 34.9 27.6C35.6 24.7 36 21.7 36 18.8C36 18.4 36 17.9 36 17.4ZM32.5 27.1C32.2 28.4 30.4 30.1 29.1 30.4C25.4 31.1 21.7 31.5 18 31.5C14.3 31.5 10.6 31.1 6.9 30.4C5.6 30.1 3.8 28.5 3.5 27.2C2 21.1 2 14.9 3.5 8.89999C3.8 7.59999 5.6 5.89999 6.9 5.59999C10.6 4.89999 14.3 4.49999 18 4.49999C21.7 4.49999 25.4 4.89999 29.1 5.59999C30.4 5.89999 32.2 7.49999 32.5 8.79999C34 14.9 34 21.1 32.5 27.1Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M13.7996 12.9C12.9996 13.4 12.5996 14.2 12.5996 15.1V21C12.5996 21.9 13.0996 22.7 13.7996 23.2C14.1996 23.5 14.6996 23.6 15.0996 23.6C15.4996 23.6 15.8996 23.5 16.1996 23.3L21.9996 20.4C22.8996 20 23.3996 19.1 23.3996 18.1C23.3996 17.1 22.8996 16.3 21.9996 15.8L16.1996 12.9C15.3996 12.4 14.4996 12.4 13.7996 12.9Z"
      fill={props.color ? props.color : 'black'}
    />
  </svg>
)
export const Carnew = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9992 22.2H14.9992C14.5992 22.2 14.1992 22.7 14.1992 23.4C14.1992 24.1 14.4992 24.6 14.9992 24.6H20.9992C21.3992 24.6 21.7992 24.1 21.7992 23.4C21.7992 22.7 21.3992 22.2 20.9992 22.2Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M12.2988 10.7H23.7988C24.3988 10.7 24.9988 11.1 25.1988 11.7L26.7988 17H9.29883L10.8988 11.7C11.0988 11.1 11.5988 10.7 12.2988 10.7ZM10.8988 27.4H5.09883C4.29883 27.4 3.59883 26.7 3.59883 25.9V21.1C3.59883 20.2 4.29883 19.5 5.09883 19.5H30.8988C31.6988 19.5 32.3988 20.2 32.3988 21.1V25.9C32.3988 26.8 31.6988 27.4 30.8988 27.4H10.8988ZM9.69883 33.1C9.69883 33.4 9.49883 33.6 9.19883 33.6H6.89883C6.59883 33.6 6.39883 33.4 6.39883 33.1V29.8H9.69883V33.1ZM29.5988 33.1C29.5988 33.4 29.3988 33.6 29.0988 33.6H26.6988C26.3988 33.6 26.1988 33.4 26.1988 33.1V29.8H29.4988V33.1H29.5988ZM30.8988 17.1H29.1988L27.2988 11C26.7988 9.40005 25.3988 8.30005 23.6988 8.30005H12.2988C10.6988 8.30005 9.19883 9.40005 8.69883 11L6.89883 17.1H5.09883C2.99883 17.1 1.29883 18.9 1.29883 21.1V25.9C1.29883 27.7 2.49883 29.2001 4.09883 29.7001V33.2001C4.09883 34.8001 5.29883 36.1 6.89883 36.1H9.29883C10.7988 36.1 12.0988 34.8001 12.0988 33.2001V29.9H23.9988V33.2001C23.9988 34.8001 25.1988 36.1 26.7988 36.1H29.1988C30.6988 36.1 31.9988 34.8001 31.9988 33.2001V29.7001C33.5988 29.2001 34.7988 27.7 34.7988 25.9V21.1C34.6988 18.9 32.9988 17.1 30.8988 17.1Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M2.39961 15.6H3.89961C4.59961 15.6 5.19961 15 5.19961 14.2C5.19961 13.4 4.59961 12.8 3.89961 12.8H2.39961C1.69961 12.8 1.09961 13.4 1.09961 14.2C1.09961 15 1.59961 15.6 2.39961 15.6Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M30.7988 14.2C30.7988 15 31.3988 15.6 32.0988 15.6H33.5988C34.2988 15.6 34.8988 15 34.8988 14.2C34.8988 13.4 34.2988 12.8 33.5988 12.8H32.0988C31.3988 12.9 30.7988 13.5 30.7988 14.2Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M4.9 6.69995L6.1 8.09995L6 6.29995L7.4 4.99995L5.5 5.09995L4.3 3.69995L4.4 5.59995L3 6.89995L4.9 6.69995Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M19.9996 5.4L20.8996 3.7L22.6996 3.4L21.0996 2.4L20.7996 0.5L19.8996 2.2L18.0996 2.5L19.6996 3.5L19.9996 5.4Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M11.6004 2.5L12.3004 1.7L13.3004 1.8L12.5004 1.1L12.6004 0L11.9004 0.8L10.9004 0.7L11.7004 1.4L11.6004 2.5Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M30.4988 6.40002L31.1988 5.60002L32.1988 5.70002L31.3988 5.00002L31.4988 3.90002L30.7988 4.70002L29.7988 4.60002L30.5988 5.30002L30.4988 6.40002Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M8.89883 22.1H7.19883C6.69883 22.1 6.29883 22.5 6.29883 23V23.9C6.29883 24.4 6.69883 24.8 7.19883 24.8H8.89883C9.39883 24.8 9.79883 24.4 9.79883 23.9V23C9.79883 22.5 9.39883 22.1 8.89883 22.1Z"
      fill={props.color ? props.color : 'black'}
    />
    <path
      d="M27.0992 24.8H28.7992C29.2992 24.8 29.6992 24.4 29.6992 23.9V23C29.6992 22.5 29.2992 22.1 28.7992 22.1H27.0992C26.5992 22.1 26.1992 22.5 26.1992 23V23.9C26.1992 24.4 26.5992 24.8 27.0992 24.8Z"
      fill={props.color ? props.color : 'black'}
    />
  </svg>
)
export const BlackFriday = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={props.color ? props.color : 'black'}
      d="M14.059,5.436V3.245l-2.204-1.102L9.712,0L7.559,0.538L5.406,0L3.263,2.143L1.059,3.245v2.191L0,7.554l1.059,2.118v2.191  l2.204,1.102l2.143,2.143l2.153-0.538l2.153,0.538l2.143-2.143l2.204-1.102V9.672l1.059-2.118L14.059,5.436z M13.059,9.436v1.809  l-1.724,0.862L9.406,14l-1.847-0.462L5.712,14l-1.8-1.8l-1.854-0.956V9.436L1.118,7.554l0.941-1.882V3.863l1.724-0.862l1.93-1.894  l1.847,0.462l1.847-0.462l1.8,1.8l1.854,0.956v1.809L14,7.554L13.059,9.436z"
    />
    <rect
      fill={props.color ? props.color : 'black'}
      height="1"
      transform="matrix(0.7071 -0.7071 0.7071 0.7071 -3.1273 7.5575)"
      width="8.485"
      x="3.316"
      y="7.054"
    />
    <path
      fill={props.color ? props.color : 'black'}
      d="M5.559,7.054c0.827,0,1.5-0.673,1.5-1.5s-0.673-1.5-1.5-1.5s-1.5,0.673-1.5,1.5S4.732,7.054,5.559,7.054z M5.559,5.054  c0.276,0,0.5,0.224,0.5,0.5s-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5S5.283,5.054,5.559,5.054z"
    />
    <path
      fill={props.color ? props.color : 'black'}
      d="M9.559,8.054c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S10.386,8.054,9.559,8.054z M9.559,10.054  c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5S9.835,10.054,9.559,10.054z"
    />
  </svg>
)

export const PortoOfertas = () => (
  <svg version="1.1" id="Layer_1" x="0px" y="0px"
	 width="100%" viewBox="0 0 304 304" enable-background="new 0 0 304 304">
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M0.999998,290.000000 
	C1.000000,202.312439 1.000000,114.624878 1.274474,26.280891 
	C5.263540,18.406887 9.029626,11.281519 16.133427,6.597778 
	C19.313038,4.501369 23.187454,3.693144 26.000000,1.000000 
	C113.020897,1.000000 200.041794,1.000000 287.725311,1.267342 
	C294.708740,4.221340 299.892944,8.554786 305.000000,13.000000 
	C305.000000,110.260994 305.000000,207.521988 305.000000,305.000000 
	C206.312546,305.000000 107.624931,305.000000 8.366597,304.653809 
	C5.530585,299.538391 3.265290,294.769196 0.999998,290.000000 
M115.216026,192.524292 
	C107.431755,195.380783 99.761536,198.624146 91.824883,200.963730 
	C86.117111,202.646255 84.075081,206.016876 83.284523,211.581665 
	C79.828606,235.908203 73.761391,259.445251 60.904217,280.761017 
	C60.454212,281.507080 59.670818,282.416565 60.833164,283.618042 
	C67.336266,280.833801 73.925682,278.096558 80.447365,275.206451 
	C115.400665,259.716705 150.594193,244.845871 187.402145,234.214066 
	C198.733521,230.941055 210.197510,228.260513 222.148102,228.621872 
	C232.726822,228.941757 236.897964,234.987137 233.052139,244.791763 
	C230.779694,250.585190 227.133789,255.546341 223.062729,260.195251 
	C221.721100,261.727295 220.133392,263.091187 220.280701,265.994263 
	C230.436722,259.041260 238.609909,250.677826 246.843094,242.616272 
	C256.519775,233.141342 265.204956,222.629501 272.020050,210.643768 
	C280.472351,195.778625 276.953522,182.288208 261.914001,176.123932 
	C249.872971,171.188599 236.978287,170.370529 224.251709,170.764374 
	C214.875183,171.054520 205.431656,171.882614 196.046921,173.216156 
	C168.692841,177.103104 142.113068,184.031555 115.216026,192.524292 
M189.077972,98.523819 
	C185.616653,98.150536 182.157837,97.485176 178.693588,97.455650 
	C165.288269,97.341377 151.901047,96.806618 138.486740,98.284401 
	C120.758606,100.237411 103.423004,103.699295 86.480965,109.250648 
	C83.382042,110.266060 81.870148,111.595238 82.260567,115.304955 
	C83.491249,126.999077 85.640213,138.615524 85.400940,150.450745 
	C85.262871,157.280334 85.415230,164.115326 85.373085,170.947495 
	C85.347481,175.098785 87.119705,176.273163 91.061600,174.947693 
	C109.328773,168.805252 128.040558,164.291641 146.796982,159.959198 
	C163.767746,156.039230 180.957092,153.195251 198.284119,151.816528 
	C209.300156,150.939972 220.353256,150.145920 231.575745,151.376144 
	C245.965286,152.953537 259.867645,155.078705 271.980469,163.693420 
	C273.271179,164.611389 274.560303,166.002213 276.531952,164.718002 
	C276.636322,164.319199 276.929871,163.819519 276.847290,163.392609 
	C276.627960,162.258698 276.284393,161.143707 275.923584,160.043030 
	C267.935791,135.676208 250.842270,119.893417 228.159149,109.372063 
	C215.998459,103.731445 203.050034,100.938248 189.077972,98.523819 
M212.446899,84.718262 
	C220.688828,87.835701 228.702866,91.464798 236.460938,95.778587 
	C236.190689,94.526382 235.765915,93.615356 235.156357,92.851852 
	C234.225082,91.685379 233.191238,90.596817 232.157700,89.516541 
	C217.064926,73.740974 198.788696,62.814968 178.799423,54.495647 
	C155.655426,44.863373 131.419479,39.450851 106.645302,36.536671 
	C93.000504,34.931641 79.229301,34.362675 65.504166,33.500572 
	C60.861252,33.208946 56.184597,33.428799 51.523727,33.463531 
	C49.995670,33.474918 48.402431,33.664448 47.817337,35.386711 
	C47.308090,36.885700 48.440414,37.868099 49.326099,38.844650 
	C51.331520,41.055813 53.536919,43.107727 55.361336,45.457104 
	C63.202747,55.554810 68.137741,67.170692 72.323547,79.103767 
	C73.726952,83.104645 76.028610,84.084793 79.905754,83.351128 
	C108.120323,78.012138 136.416733,74.421593 165.305267,76.445580 
	C181.121811,77.553726 196.560028,79.844543 212.446899,84.718262 
z"/>
</svg>
)

export const PrevArrow = (props) => (
  <svg
    id="Grupo_249"
    data-name="Grupo 249"
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <g id="Grupo_40" data-name="Grupo 40">
      <circle
        id="Elipse_1"
        data-name="Elipse 1"
        cx="24"
        cy="24"
        r="24"
        fill="#fff"
      />
      <g id="Grupo_39" data-name="Grupo 39" transform="translate(14 14)">
        <rect
          id="Retângulo_14"
          data-name="Retângulo 14"
          width="20"
          height="20"
          fill="none"
        />
        <path
          id="Vector"
          d="M16.842,10.586a.915.915,0,0,1-.474.142.638.638,0,0,1-.569-.237L8.544,1.814l-7.3,8.677a.735.735,0,0,1-1,.095.735.735,0,0,1-.095-1L7.975.249a.722.722,0,0,1,1.091,0L16.89,9.59a.687.687,0,0,1-.047,1Z"
          transform="matrix(-0.017, -1, 1, -0.017, 4.926, 18.778)"
          fill="#006fd6"
          stroke="#006fd6"
          stroke-width="1"
        />
      </g>
    </g>
  </svg>
)
export const NextArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <g
      id="Grupo_250"
      data-name="Grupo 250"
      transform="translate(48 48) rotate(180)"
    >
      <g id="Grupo_40" data-name="Grupo 40">
        <circle
          id="Elipse_1"
          data-name="Elipse 1"
          cx="24"
          cy="24"
          r="24"
          fill="#fff"
        />
        <g id="Grupo_39" data-name="Grupo 39" transform="translate(14 14)">
          <rect
            id="Retângulo_14"
            data-name="Retângulo 14"
            width="20"
            height="20"
            fill="none"
          />
          <path
            id="Vector"
            d="M16.842,10.586a.915.915,0,0,1-.474.142.638.638,0,0,1-.569-.237L8.544,1.814l-7.3,8.677a.735.735,0,0,1-1,.095.735.735,0,0,1-.095-1L7.975.249a.722.722,0,0,1,1.091,0L16.89,9.59a.687.687,0,0,1-.047,1Z"
            transform="matrix(-0.017, -1, 1, -0.017, 4.926, 18.778)"
            fill="#006fd6"
            stroke="#006fd6"
            stroke-width="1"
          />
        </g>
      </g>
    </g>
  </svg>
)
export const TrocarPontos = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 35.194 35.241"
  >
    <path
      id="Caminho_630"
      data-name="Caminho 630"
      d="M434.13,502.374h-4.1v-1.921a3.667,3.667,0,0,0-2.019-3.289,3.715,3.715,0,0,0-3.843.326l-6.318,4.689-6.318-4.689a3.579,3.579,0,0,0-3.843-.326,3.667,3.667,0,0,0-2.019,3.289v1.921h-4.1a.806.806,0,0,0-.814.814V509.7a.806.806,0,0,0,.814.814h1.628v17.228a3.2,3.2,0,0,0,3.192,3.191H429.31a3.2,3.2,0,0,0,3.191-3.191V510.548h1.628a.806.806,0,0,0,.814-.814v-6.546A.806.806,0,0,0,434.13,502.374Zm-9.021-3.582a1.988,1.988,0,0,1,2.149-.2,2.022,2.022,0,0,1,1.14,1.856v1.921H420.29l4.82-3.582ZM407.3,500.453a2.057,2.057,0,0,1,1.14-1.856,1.988,1.988,0,0,1,2.149.2l4.82,3.582H407.3v-1.921ZM402.378,504h14.752v4.918H402.378V504Zm2.443,23.741V510.548h12.342v18.79H406.384a1.563,1.563,0,0,1-1.563-1.563m26.085,0a1.563,1.563,0,0,1-1.563,1.563H418.792v-18.79h12.115Zm2.442-18.856h-14.59v-4.885h14.557v4.885Z"
      transform="translate(-400.25 -496.194)"
      fill={props.color ? props.color : '#fff'}
      stroke="#fff"
      stroke-width="1"
    />
  </svg>
)

export const Desconto = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40.079"
    height="40"
    viewBox="0 0 40.079 25.392"
  >
    <g id="Grupo_112" data-name="Grupo 112" transform="translate(0.5 0.5)">
      <path
        id="Caminho_95"
        data-name="Caminho 95"
        d="M99.823,66.255H67.257A3.266,3.266,0,0,0,64,69.512V87.39a3.266,3.266,0,0,0,3.257,3.257H99.823a3.266,3.266,0,0,0,3.257-3.257V69.544a3.266,3.266,0,0,0-3.257-3.257M65.628,87.423V69.544a1.633,1.633,0,0,1,1.628-1.628H77.547a12.1,12.1,0,0,0,.033,21.168H67.257a1.633,1.633,0,0,1-1.628-1.628M83.54,67.883A10.584,10.584,0,1,1,72.956,78.467,10.6,10.6,0,0,1,83.54,67.883Zm17.911,19.54a1.633,1.633,0,0,1-1.628,1.628H89.5a12.115,12.115,0,0,0,0-21.168H99.79a1.633,1.633,0,0,1,1.628,1.628V87.39Z"
        transform="translate(-64 -66.255)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
      <path
        id="Caminho_96"
        data-name="Caminho 96"
        d="M71.909,80.546v.586a.814.814,0,0,0,1.628,0v-.521a3.569,3.569,0,0,0,3.257-3.159c0-2.442-2.117-3.061-3.647-3.55-1.661-.521-2.312-.814-2.312-1.726,0-.977.944-1.433,1.824-1.433a2.126,2.126,0,0,1,2.182,1.335.814.814,0,1,0,1.563-.456,3.718,3.718,0,0,0-2.833-2.345v-.619a.814.814,0,0,0-1.628,0v.586a3.064,3.064,0,0,0-2.736,2.931c0,2.214,1.987,2.833,3.452,3.257,1.726.521,2.508.879,2.508,1.987,0,.684-.847,1.368-1.889,1.563a2.449,2.449,0,0,1-2.866-1.856.826.826,0,0,0-1.042-.521.8.8,0,0,0-.521,1.042,4.048,4.048,0,0,0,3.094,2.9"
        transform="translate(-53.149 -62.667)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
    </g>
  </svg>
)
export const CashBack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40.079"
    height="40"
    viewBox="0 0 40.079 25.49"
  >
    <g id="Grupo_190" data-name="Grupo 190" transform="translate(0.5 0.5)">
      <path
        id="Caminho_438"
        data-name="Caminho 438"
        d="M148.637,642.273H114.41a2.4,2.4,0,0,0-2.41,2.41V648a.806.806,0,0,0,.814.814,5.667,5.667,0,0,1,0,11.333.806.806,0,0,0-.814.814v3.322a2.432,2.432,0,0,0,2.41,2.443h34.227a2.46,2.46,0,0,0,2.442-2.443v-19.6a2.46,2.46,0,0,0-2.442-2.442m.814,21.982a.806.806,0,0,1-.814.814h-23.61a.814.814,0,0,0-1.628,0H114.41a.8.8,0,0,1-.814-.781v-2.54a7.289,7.289,0,0,0,.033-14.492v-2.54a.779.779,0,0,1,.782-.814H123.4a.814.814,0,1,0,1.628,0h23.643a.806.806,0,0,1,.814.814v19.572Z"
        transform="translate(-112 -642.24)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
      <path
        id="Caminho_439"
        data-name="Caminho 439"
        d="M116.314,643.43a.806.806,0,0,0-.814.814v1.5a.814.814,0,0,0,1.628,0v-1.5a.806.806,0,0,0-.814-.814"
        transform="translate(-104.102 -639.555)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
      <path
        id="Caminho_440"
        data-name="Caminho 440"
        d="M116.314,646.21a.806.806,0,0,0-.814.814v1.5a.814.814,0,0,0,1.628,0v-1.5A.806.806,0,0,0,116.314,646.21Z"
        transform="translate(-104.102 -633.281)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
      <path
        id="Caminho_441"
        data-name="Caminho 441"
        d="M116.314,644.82a.806.806,0,0,0-.814.814v1.5a.814.814,0,0,0,1.628,0v-1.5A.806.806,0,0,0,116.314,644.82Z"
        transform="translate(-104.102 -636.418)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
      <path
        id="Caminho_442"
        data-name="Caminho 442"
        d="M116.314,647.6a.806.806,0,0,0-.814.814v1.5a.814.814,0,1,0,1.628,0v-1.5A.806.806,0,0,0,116.314,647.6Z"
        transform="translate(-104.102 -630.145)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
      <path
        id="Caminho_443"
        data-name="Caminho 443"
        d="M130.745,644.4a.787.787,0,0,0-1.14,0l-11.724,11.659a.806.806,0,0,0,1.14,1.14l11.724-11.658A.787.787,0,0,0,130.745,644.4Z"
        transform="translate(-99.28 -637.918)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
      <path
        id="Caminho_444"
        data-name="Caminho 444"
        d="M120.4,650.519h.423a3.288,3.288,0,1,0-.423-.033m.423-4.852h.2a1.727,1.727,0,0,1,1.075.619,1.626,1.626,0,1,1-2.9.782,1.649,1.649,0,0,1,1.628-1.433"
        transform="translate(-99.429 -638.241)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
      <path
        id="Caminho_445"
        data-name="Caminho 445"
        d="M123.537,646.343a3.252,3.252,0,0,0-.847,6.448h.423a3.254,3.254,0,0,0,.423-6.481m-.619,4.852a1.638,1.638,0,0,1-1.4-1.824,1.621,1.621,0,0,1,1.628-1.4h.228a1.638,1.638,0,0,1,1.4,1.824,1.662,1.662,0,0,1-1.824,1.4"
        transform="translate(-94.257 -633.056)"
        fill="#fff"
        stroke="#fff"
        stroke-width="1"
      />
    </g>
  </svg>
)
export const CredtCard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="credit-card"
          width="24"
          height="24"
          fill="none"
          style="mix-blend-mode: normal;isolation: isolate"
        />
      </clipPath>
    </defs>
    <g
      id="credit-card-2"
      data-name="credit-card"
      clip-path="url(#clip-path)"
      style="mix-blend-mode: normal;isolation: isolate"
    >
      <rect
        id="credit-card-3"
        data-name="credit-card"
        width="24"
        height="24"
        fill="none"
        style="mix-blend-mode: normal;isolation: isolate"
      />
      <g
        id="Group"
        transform="translate(0 2.733)"
        style="mix-blend-mode: normal;isolation: isolate"
      >
        <path
          id="Vector"
          d="M19.8,0H4.2A4.183,4.183,0,0,0,0,4.2v8.667a4.183,4.183,0,0,0,4.2,4.2H19.867a4.183,4.183,0,0,0,4.2-4.2V4.2A4.283,4.283,0,0,0,19.8,0ZM4.2,1.6H19.867a2.6,2.6,0,0,1,2.6,2.6V5.6H1.6V4.2A2.6,2.6,0,0,1,4.2,1.6ZM19.8,15.467H4.2a2.6,2.6,0,0,1-2.6-2.6V8.533H22.4v4.333A2.562,2.562,0,0,1,19.8,15.467Z"
          fill="#404040"
          style="mix-blend-mode: normal;isolation: isolate"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M8.133,0H.8A.77.77,0,0,0,0,.8a.77.77,0,0,0,.8.8H8.133a.77.77,0,0,0,.8-.8A.811.811,0,0,0,8.133,0Z"
          transform="translate(3.4 11.067)"
          fill="#404040"
          style="mix-blend-mode: normal;isolation: isolate"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M4.333,0H.8A.77.77,0,0,0,0,.8a.77.77,0,0,0,.8.8H4.333a.77.77,0,0,0,.8-.8A.77.77,0,0,0,4.333,0Z"
          transform="translate(14 11.067)"
          fill="#404040"
          style="mix-blend-mode: normal;isolation: isolate"
        />
      </g>
    </g>
  </svg>
)
